window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value;
  },

  /**
   * Constructs an object of key / value pairs out of the parameters of the query string
   *
   * @return {Object}
   */
  getQueryParams: function() {
    var queryString = location.search && location.search.substr(1) || '';
    var queryParams = {};

    queryString
      .split('&')
      .filter(function (element) {
        return element.length;
      })
      .forEach(function (paramValue) {
        var splitted = paramValue.split('=');

        if (splitted.length > 1) {
          queryParams[splitted[0]] = splitted[1];
        } else {
          queryParams[splitted[0]] = true;
        }
      });

    return queryParams;
  },

  /**
   * Returns empty string or query string with '?' prefix
   *
   * @return (string)
   */
  getQueryString: function() {
    var queryString = location.search && location.search.substr(1) || '';

    // Add the '?' prefix if there is an actual query
    if(queryString.length){
      queryString = '?' + queryString;
    }

    return queryString;
  },

  /**
   * Constructs a version of the current URL with the passed in key value pair as part of the query string
   * Will also remove the key if an empty value is passed in
   * See: https://gist.github.com/niyazpk/f8ac616f181f6042d1e0
   *
   * @param {String} key
   * @param {String} value
   * @param {String} uri - optional, defaults to window.location.href
   * @return {String}
   */
  getUrlWithUpdatedQueryStringParameter: function(key, value, uri) {

    uri = uri || window.location.href;

    // remove the hash part before operating on the uri
    var i = uri.indexOf('#');
    var hash = i === -1 ? ''  : uri.substr(i);
    uri = i === -1 ? uri : uri.substr(0, i);

    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";

    if (!value) {
      // remove key-value pair if value is empty
      uri = uri.replace(new RegExp("([?&]?)" + key + "=[^&]*", "i"), '');
      if (uri.slice(-1) === '?') {
        uri = uri.slice(0, -1);
      }
      // replace first occurrence of & by ? if no ? is present
      if (uri.indexOf('?') === -1) uri = uri.replace(/&/, '?');
    } else if (uri.match(re)) {
      uri = uri.replace(re, '$1' + key + "=" + value + '$2');
    } else {
      uri = uri + separator + key + "=" + value;
    }
    return uri + hash;
  },

  /**
   * Constructs a version of the current URL with the passed in parameter key and associated value removed
   *
   * @param {String} key
   * @return {String}
   */
  getUrlWithRemovedQueryStringParameter: function(parameterKeyToRemove, uri) {
    uri = uri || window.location.href;

    var rtn = uri.split("?")[0],
        param,
        params_arr = [],
        queryString = (uri.indexOf("?") !== -1) ? uri.split("?")[1] : "";

    if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
            param = params_arr[i].split("=")[0];
            if (param === parameterKeyToRemove) {
                params_arr.splice(i, 1);
            }
        }
         if (params_arr.length > 0) {
          rtn = rtn + "?" + params_arr.join("&");
        }
    }

    return rtn;
  },

  /**
   * Check if we're running the theme inside the theme editor
   *
   * @return {bool}
   */
  isThemeEditor: function() {
    return location.href.match(/myshopify.com/) !== null && location.href.match(/theme_id/) !== null;
  },

  /**
   * Get the name of the correct 'transitionend' event for the browser we're in
   *
   * @return {string}
   */
  whichTransitionEnd: function() {
    var t;
    var el = document.createElement('fakeelement');
    var transitions = {
      'transition':'transitionend',
      'OTransition':'oTransitionEnd',
      'MozTransition':'transitionend',
      'WebkitTransition':'webkitTransitionEnd'
    };

    for(t in transitions){
      if( el.style[t] !== undefined ){
        return transitions[t];
      }
    }
  },

  /**
   * Adds user agent classes to the document to target specific browsers
   *
   */
  userAgentBodyClass: function() {
    var ua = navigator.userAgent,
        d = document.documentElement,
        classes = d.className,
        matches;

    // Detect iOS (needed to disable zoom on form elements)
    // http://stackoverflow.com/questions/9038625/detect-if-device-is-ios/9039885#9039885
    if ( /iPad|iPhone|iPod/.test(ua) && !window.MSStream ) {
      classes += ' ua-ios';

      // Add class for version of iOS
      matches = ua.match(/((\d+_?){2,3})\slike\sMac\sOS\sX/);
      if ( matches ) {
        classes += ' ua-ios-' + matches[1];// e.g. ua-ios-7_0_2
      }

      // Add class for Twitter app
      if ( /Twitter/.test(ua) ) {
        classes += ' ua-ios-twitter';
      }

      // Add class for Chrome browser
      if ( /CriOS/.test(ua) ) {
        classes += ' ua-ios-chrome';
      }
    }

    // Detect Android (needed to disable print links on old devices)
    // http://www.ainixon.me/how-to-detect-android-version-using-js/
    if ( /Android/.test(ua) ) {
      matches = ua.match(/Android\s([0-9\.]*)/);
      classes += matches ? ' ua-aos ua-aos-' + matches[1].replace(/\./g,'_') : ' ua-aos';
    }

    // Detect webOS (needed to disable optimizeLegibility)
    if ( /webOS|hpwOS/.test(ua) ) {
      classes += ' ua-webos';
    }

    // Detect Samsung Internet browser
    if ( /SamsungBrowser/.test(ua) ) {
      classes += ' ua-samsung';
    }

    d.className = classes;
  },

  /**
   * Generates a 32 bit integer from a string
   * Reference - https://stackoverflow.com/a/7616484
   *
   * @param {string}
   * @return {int}
   */
  hashFromString: function(string) {
    var hash = 0, i, chr;
    if (string.length === 0) return hash;
    for (i = 0; i < string.length; i++) {
      chr   = string.charCodeAt(i);
      hash  = ((hash << 5) - hash) + chr;
      hash |= 0; // Convert to 32bit integer
    }
    return hash;
  },

  chosenSelects: function($container) {
    var $selects = $container ? $('select.form-control', $container) : $('select.form-control');
    $selects.not('[data-no-chosen]').chosen();

    // Allows browser autofill to function properly
    $selects.on('change', function() {
      $(this).trigger('chosen:updated');
    });
  },

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  },

  /**
   * Pluralizes the unit for the nuber passed in.
   * Usage mirrors the Shopify "pluralize" string filter
   *
   * @param {Number} number
   * @param {String} singular
   * @param {String} plural
   * @return {String}
   */
  pluralize: function(number, singular, plural)  {
    var output = '';

    number = parseInt(number);

    if(number == 1) {
      output = singular;
    }
    else {
      output = plural;
      if (typeof plural == "undefined") {
        output = singular + 's'; // last resort, turn singular into a plural
      }
    }
    return output;
  }

};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {

  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTables: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;
    
    options.$tables.addClass('table');
    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },  

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + options.iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  /**
   * Removes '.00' if found at the end of the string
   *
   * @param  {string} value - formatted price (see above)
   * @return {string} value - formatted value
   */
  function stripZeroCents(string) {
    return string.replace(/\.00$/,'');
  }

  return {
    formatMoney: formatMoney,
    stripZeroCents: stripZeroCents
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */
  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();

/**
 * AJAX Cart scripts
 * ------------------------------------------------------------------------------
 *
 * This is a bare-bones but completely usable implementation of an AJAX enabled cart
 * 
 * Usage: slate.AjaxCart.init(options);
 *
 * See the following list of stubbed / incomplete methods that need to be filled in
 *
 *   - AjaxCart.onOpenClick
 *   - AjaxCart.onCloseClick
 *   - AjaxCart.open
 *   - AjaxCart.close
 *   - AjaxCart.onItemAddFail
 *   - AjaxCart.buildCart
 *
 */

(function($, Handlebars, slate){

  if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

  /*============================================================================
    API Functions
  ==============================================================================*/

 /**
  * AJAX submit an 'add to cart' form
  *
  * @param {jQuery} $form - jQuery instance of the form
  * @return {Promise} - Resolve returns JSON cart | Reject returns an error message
  */
  ShopifyAPI.addItemFromForm = function($form) {
    var promise = $.Deferred();

    $.ajax({
      type: 'post',
      dataType: 'json',
      url: '/cart/add.js',
      data: $form.serialize(),
      success: function () {
        ShopifyAPI.getCart().then(function (data) {
          promise.resolve(data);
        });
      },
      error: function () {
        promise.reject({
          message: 'The quantity you entered is not available.'
        });
      }
    });

    return promise;
  };

 /**
  * Retrieve a JSON respresentation of the users cart
  *
  * @return {Promise} - JSON cart
  */
  ShopifyAPI.getCart = function() {
    var promise = $.Deferred();

    var url = slate.utils.isThemeEditor() ? '/cart.js' : '/cart?view=json'; // Theme editor inserts HTML comments in custom templates and breaks JSON response
    
    $.ajax({
      type: 'get',
      url: url,
      success: function (data) {
        var cart = JSON.parse(data);
        promise.resolve(cart);
      },
      error: function () {
        promise.reject({
          message: 'Could not retrieve cart items'
        });
      }
    });

    return promise;
  };

 /**
  * Retrieve a JSON respresentation of the users cart
  *
  * @return {Promise} - JSON cart
  */
  ShopifyAPI.getProduct = function(handle) {
    return $.getJSON('/products/' + handle + '.js');
  };  

 /**
  * Change the quantity of an item in the users cart
  *
  * @param {int} line - Cart line
  * @param {int} qty - New quantity of the variant
  * @return {Promise} - JSON cart
  */
  ShopifyAPI.changeLineItemQuantity = function(line, qty) {
    return $.ajax({
      type: 'post',
      dataType: 'json',
      url: '/cart/change.js',
      data: 'quantity=' + qty + '&line=' + line
    });
  };

  /*============================================================================
    Ajax Shopify Add To Cart
  ==============================================================================*/
  slate.AjaxCart = (function() {
    
    var $window = $(window);
    var $body = $('body');

    var selectors = {
      container: '[data-ajax-cart-container]',
      template: 'script[data-ajax-cart-template]',
      trigger: '[data-ajax-cart-trigger]',
      close: '[data-ajax-cart-close]',
      addForm: 'form[action^="/cart/add"]',
      addToCart: '[data-add-to-cart]',
      addToCartText: '[data-add-to-cart-text]',
      header: '[data-ajax-cart-header]',
      body: '[data-ajax-cart-body]',
      footer: '[data-ajax-cart-footer]',
      item: '[data-ajax-item][data-id][data-qty]',
      itemRemove: '[data-ajax-cart-item-remove]',
      itemIncrement: '[data-ajax-cart-item-increment]',
      itemDecrement: '[data-ajax-cart-item-decrement]',
      cartBadge: '[data-cart-badge]',
      cartBadgeCount: '[data-cart-badge-count]',
      slideshow: '[data-slideshow]'
    };

    var classes = {
      bodyCartOpen: 'ajax-cart-open',
      backdrop: 'ajax-cart-backdrop',
      backdropVisible: 'is-visible',
      cartOpen: 'is-open',
      cartBadgeHasItems: 'has-items',
      cartRequestInProgress: 'request-in-progress'
    };

   /**
    * AjaxCart constructor
    *
    * Adds an `init` method with access to private variables inside the contructor
    */
    function AjaxCart() {
      this.name = 'ajaxCart';
      this.namespace = '.' + this.name;
      this.events = {
        RENDER:  'render'  + this.namespace,
        DESTROY: 'destroy' + this.namespace,
        SCROLL:  'scroll'  + this.namespace,
        UPDATE:  'update'  + this.namespace //  Use this as a global event to hook into whenever the cart changes
      };   

      var initialized = false;
      var settings = {
        disableAjaxCart: false,
        backdrop: true
      };

      this.$el                = $(selectors.container);
      this.$backdrop          = null;
      this.stateIsOpen        = null;
      this.transitionEndEvent = slate.utils.whichTransitionEnd();
      this.requestInProgress  = false;

     /**
      * Initialize the cart
      *
      * @param {object} options - see `settings` variable above
      */
      this.init = function(options) {
        if(initialized) return;

        this.settings = $.extend(settings, options);

        if(!$(selectors.template).length){
          console.warn('['+this.name+'] - Handlebars template required to initialize');
          return;
        }

        this.$container      = $(selectors.container);
        this.$cartBadge      = $(selectors.cartBadge);
        this.$cartBadgeCount = $(selectors.cartBadgeCount);        

        // Compile this once during initialization
        this.template = Handlebars.compile($(selectors.template).html());

        // Add the AJAX part
        if(!this.settings.disableAjaxCart) {
          this._formOverride();
        }

        // Add event handlers here
        $body.on('click', selectors.trigger, this.onTriggerClick.bind(this));
        $body.on('click', selectors.close, this.onCloseClick.bind(this));
        $body.on('click', selectors.itemRemove, this.onItemRemoveClick.bind(this));
        $body.on('click', selectors.itemIncrement, this.onItemIncrementClick.bind(this));
        $body.on('click', selectors.itemDecrement, this.onItemDecrementClick.bind(this));
        $window.on(this.events.RENDER, this.onCartRender.bind(this));
        $window.on(this.events.DESTROY, this.onCartDestroy.bind(this));

        // Get the cart data when we initialize the instance
        ShopifyAPI.getCart().then(this.buildCart.bind(this));

        initialized = true;

        return initialized;
      };

      return this;
    }

    AjaxCart.prototype = $.extend({}, AjaxCart.prototype, {

     /**
      * Call this function to AJAX-ify any add to cart forms on the page
      */
      _formOverride: function() {
        var _this = this;

        $body.on('submit', selectors.addForm, function(e) {
          e.preventDefault();

          if(this.requestInProgress) return;

          var $submitButton = $(e.target).find(selectors.addToCart);
          var $submitButtonText = $submitButton.find(selectors.addToCartText);

          // Update the submit button text and disable the button so the user knows the form is being submitted
          $submitButton.prop('disabled', true);
          $submitButtonText.html(theme.strings.adding);

          this._onRequestStart();

          ShopifyAPI.addItemFromForm( $(e.target) )
            .then(function(data) {
              _this._onRequestFinish();
              // Reset button state
              $submitButton.prop('disabled', false);
              $submitButtonText.html(theme.strings.addToCart);
              _this.onItemAddSuccess.call(_this, data);
            })
            .fail(function(data) {
              _this._onRequestFinish();
              // Reset button state
              $submitButton.prop('disabled', false);
              $submitButtonText.html(theme.strings.addToCart);
              _this.onItemAddFail.call(_this, data);
            });
        }.bind(this));
      },  

     /**
      * Ensure we are working with a valid number
      *
      * @param {int|string} qty
      * @return {int} - Integer quantity.  Defaults to 1
      */
      _validateQty: function(qty) {
        return (parseFloat(qty) == parseInt(qty)) && !isNaN(qty) ? qty : 1;
      },

     /**
      * Ensure we are working with a valid number
      *
      * @param {element} el - cart item row or child element
      * @return {obj}
      */
      _getItemRowAttributes: function(el) {
        var $el = $(el);
        var $row = $el.is(selectors.item) ? $el : $el.parents(selectors.item);

        return {
          $row: $row,
          id:  $row.data('id'),
          line: ($row.index() + 1),
          qty: this._validateQty($row.data('qty'))
        };
      },

      _onRequestStart: function() {
        this.requestInProgress = true;
        this.$el.addClass(classes.cartRequestInProgress);
      },

      _onRequestFinish: function() {
        this.requestInProgress = false;
        this.$el.removeClass(classes.cartRequestInProgress);
      },      

      addBackdrop: function(callback) {

        var _this = this;
        var cb    = callback || $.noop;

        if(this.stateIsOpen) {
          this.$backdrop = $(document.createElement('div'));

          this.$backdrop.addClass(classes.backdrop)
                        .appendTo($body);

          this.$backdrop.one(this.transitionEndEvent, cb);
          this.$backdrop.one('click', this.close.bind(this));

          // debug this...
          setTimeout(function() {
            _this.$backdrop.addClass(classes.backdropVisible);
          }, 10);
        }
        else {
          cb();
        }
      },

      removeBackdrop: function(callback) {

        var _this = this;
        var cb    = callback || $.noop;

        if(!this.stateIsOpen && this.$backdrop) {
          this.$backdrop.one(this.transitionEndEvent, function(){
            _this.$backdrop && _this.$backdrop.remove();
            _this.$backdrop = null;
            cb();
          });

          setTimeout(function() {
            _this.$backdrop.removeClass(classes.backdropVisible);
          }, 10);
        }
        else {
          cb();
        }
      },

     /**
      * Callback when adding an item is successful
      *
      * @param {Object} cart - JSON representation of the cart.
      */
      onItemAddSuccess: function(cart){
        this.buildCart(cart);
        this.open();
      },

     /**
      * STUB - Callback when adding an item fails

      * @param {Object} data
      * @param {string} data.message - error message
      */
      onItemAddFail: function(data){
        console.log('['+this.name+'] - onItemAddFail');
        console.warn('['+this.name+'] - ' + data.message);
      },

      /**
      * Callback for when the cart HTML is rendered to the page
      * Allows us to add event handlers for events that don't bubble
      */
      onCartRender: function(e) {
        // console.log('['+this.name+'] - onCartRender');
      },

     /**
      * Callback for when the cart HTML is removed from the page
      * Allows us to do cleanup on any event handlers applied post-render
      */
      onCartDestroy: function(e) {
        // console.log('['+this.name+'] - onCartDestroy');
      },

     /**
      * Builds the HTML for the ajax cart.
      * Modifies the JSON cart for consumption by our handlebars template
      *
      * @param {object} cart - JSON representation of the cart.  See https://help.shopify.com/themes/development/getting-started/using-ajax-api#get-cart
      * @return ??
      */
      buildCart: function(cart) {

        // All AJAX Cart requests finish with rebuilding the cart
        // So this is a good place to add this code
        this._onRequestFinish();

        // Make adjustments to the cart object contents before we pass it off to the handlebars template
        cart.total_price = slate.Currency.formatMoney(cart.total_price, theme.moneyFormat);
        // cart.total_price = slate.Currency.stripZeroCents(cart.total_price);

        cart.items.map(function(item){
          item.image    = slate.Image.getSizedImageUrl(item.image, '200x');
          item.price    = slate.Currency.formatMoney(item.price, theme.moneyFormat);
          // item.price = slate.Currency.stripZeroCents(item.price);

          // Adjust the item's variant options to add "name" and "value" properties
          if(item.hasOwnProperty('product')) {
            var product = item.product;
            for (var i = item.variant_options.length - 1; i >= 0; i--) {
              var name  = product.options[i];
              var value = item.variant_options[i];

              item.variant_options[i] = {
                name: name,
                value: value
              };

              // Don't show this info if it's the default variant that Shopify creates
              if(value == "Default Title") {
                delete item.variant_options[i];
              }
            }
          }
          else {
            delete item.variant_options; // skip it and use the variant title instead
          }

          return item;
        });

        /**
         *  You can also use this as an intermediate step to constructing the AJAX cart DOM
         *  by returning an HTML string and using another function to do the DOM updating
         *
         *  return this.template(cart)
         *
         *  The code below isn't the most elegant way to update the cart but it works...
         */        

        $window.trigger(this.events.DESTROY);
        this.$container.empty().append( this.template(cart) );
        $window.trigger(this.events.RENDER);
        $window.trigger(this.events.UPDATE);

        this.updateCartCount(cart);
        this.giftCarouselConditionalInit();
      },

     /**
      * Update the cart badge + count here
      *
      * @param {Object} cart - JSON representation of the cart.
      */
      updateCartCount: function(cart) {

        this.$cartBadgeCount.html("(" + cart.item_count + ")");

        if(cart.item_count) {
          this.$cartBadge.addClass(classes.cartBadgeHasItems);
        }
        else {
          this.$cartBadge.removeClass(classes.cartBadgeHasItems);
        }
      },

     /**
      * Remove the item from the cart.  Extract this into a separate method if there becomes more ways to delete an item
      *
      * @param {event} e - Click event
      */
      onItemRemoveClick: function(e) {
        e.preventDefault();

        if(this.requestInProgress) return;

        var attrs = this._getItemRowAttributes(e.target);

        this._onRequestStart();
        ShopifyAPI.changeLineItemQuantity(attrs.line, 0).then(ShopifyAPI.getCart).then(this.buildCart.bind(this));
      },

     /**
      * Increase the quantity of an item by 1
      *
      * @param {event} e - Click event
      */
      onItemIncrementClick: function(e) {
        e.preventDefault();

        if(this.requestInProgress) return;

        var attrs = this._getItemRowAttributes(e.target);

        this._onRequestStart();
        ShopifyAPI.changeLineItemQuantity(attrs.line, attrs.qty + 1).then(ShopifyAPI.getCart).then(this.buildCart.bind(this));
      },

     /**
      * Decrease the quantity of an item by 1
      *
      * @param {event} e - Click event
      */
      onItemDecrementClick: function(e) {
        e.preventDefault();

        if(this.requestInProgress) return;

        var attrs = this._getItemRowAttributes(e.target);
        var newQty = (attrs.qty < 1 ? 0 : attrs.qty - 1);

        this._onRequestStart();
        ShopifyAPI.changeLineItemQuantity(attrs.line, newQty).then(ShopifyAPI.getCart).then(this.buildCart.bind(this));
      },

     /**
      * Click the 'ajaxCart - trigger' selector
      *
      * @param {event} e - Click event
      */
      onTriggerClick: function(e) {
        e.preventDefault();
        this.toggleVisibility();
      },

     /**
      * Click the 'ajaxCart - close' selector
      *
      * @param {event} e - Click event
      */
      onCloseClick: function(e) {
        e.preventDefault();

        // Do any cleanup before closing the cart
        this.close();
      },

     /**
      * Opens / closes the cart depending on state
      *
      */
      toggleVisibility: function() {
        return this.stateIsOpen ? this.close() : this.open();
      },

     /**
      * Check the open / closed state of the cart
      *
      * @return {bool}
      */
      isOpen: function() {
        return this.stateIsOpen;
      },

     /**
      * Returns true is the cart is closed.
      *
      * @return {bool}
      */
      isClosed: function() {
        return !this.stateIsOpen;
      },

      /**
      * STUB METHOD - check the number of gifts available and init a carousel if there is more than one
      */
      giftCarouselConditionalInit: function() {
        var shouldSlick = $(selectors.slideshow, this.$container).children().length > 1 ? true : false;
        if (shouldSlick) {
          var settings = {
            fade: false,
            dots: false,
            arrows: true,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            cssEase: slate.animations.getTransitionTimingFunction("inOutUI"),
            speed: slate.animations.getTransitionTimingDuration("slow"),
          };

          this.slideshow = new slate.models.Slideshow( $(selectors.slideshow, this.$container), settings);
        }
      },

     /**
      * STUB METHOD - Code for opening the cart
      */
      open: function() {
        if(this.stateIsOpen) return;
        this.stateIsOpen = true;

        if(this.settings.backdrop) {
          $body.addClass(classes.bodyCartOpen);
          this.addBackdrop();
        }

        this.$el.addClass(classes.cartOpen);
      },

     /**
      * STUB METHOD - Code for closing the cart
      */
      close: function() {
        if(!this.stateIsOpen) return;

        this.stateIsOpen = false;

        this.$el.removeClass(classes.cartOpen);
  
        if(this.settings.backdrop) {
          this.removeBackdrop(function() {
            $body.removeClass(classes.bodyCartOpen);
          });          
        }

      }
    });

    return AjaxCart;
  })();

})(jQuery, Handlebars, slate);


/**
 * AJAX Klaviyo Library
 * -----------------------------------------------------------------------------
 * Handles AJAX form submission and callback event
 *
 * Usage:
 *
 *   var $form = $('form');
 *   var listId = $form.data('list-id');
 *   var source = $form.data('source');
 *
 *   var options = {
 *     listId: listId,
 *     source: source,
 *     onSubscribeSuccess: function() { .. },
 *     onSubmitFail: function(){ .. }
 *   };
 *
 *   var ajaxKlaviyoForm = new slate.AjaxKlaviyoForm($form, options);
 *
 * @namespace ajaxKlaviyoForm
 */


slate.AjaxKlaviyoForm = (function($) {
  var classes = {
    checkboxHasError: 'has-error',
    formGroupHasError: 'alert-info'
  };

 /**
  * AJAX Klaviyo Form Constructor
  *
  * @param {HTMLElement | jQuery} form - Form element
  * @param {Object} options
  * @param {String} options.listId - Klaviyo List ID
  * @param {String} options.source - Klaviyo custom $source property
  * @param {String} options.newsletter - Klaviyo custom $newsletter property
  * @param {Function} options.onInit
  * @param {Function} options.onBeforeSend - Prevent AJAX submission by returning false here
  * @param {Function} options.onSubmitFail
  * @param {Function} options.onSubscribeSuccess
  * @param {Function} options.onSubscribeFail
  * @return {self}
  */
  function AjaxKlaviyoForm(form, options) {

    this.name = 'ajaxKlaviyoForm';
    this.namespace = '.' + this.name;
    this.events = {
      SUBMIT: 'submit' + this.namespace,
      CLICK: 'click' + this.namespace
    };

    var _this = this;
    var defaults = {
      source: "Shopify Form",
      onInit: $.noop,
      onBeforeSend: $.noop,
      onSubmitFail: $.noop,
      onSubscribeSuccess: $.noop,
      onSubscribeFail: $.noop
    };

    if (form.length === 0) {
      return false;
    }

    this.$form    = form instanceof jQuery ? form : $(form);
    this.$input   = this.$form.find('input[type="email"]');
    this.$newsletter = this.$form.find('[data-klaviyo-select-newsletter]');
    this.$checkboxes = this.$form.find('input[type="checkbox"]');
    this.$submit  = this.$form.find('[type="submit"]');
    this.settings = $.extend({}, defaults, options);

    if(!this.settings.listId) {
      console.warn('['+this.name+'] - Valid Klaviyo List ID required to initialize');
      return;
    }

    this.$form.on(this.events.SUBMIT, this.onFormSubmit.bind(_this));
    this.$checkboxes.on(this.events.CLICK, this.onCheckboxClick.bind(this));

    this.settings.onInit();

    return this;
  }

  AjaxKlaviyoForm.prototype = $.extend({}, AjaxKlaviyoForm.prototype, {
    logErrors: function(errors) {
      if(Array.isArray(errors) && errors.length) {
        for (var i = errors.length - 1; i >= 0; i--) {
          console.warn('['+this.name+'] - onSubmitFail error: "' + errors[i] + '"');
        }
      }
    },
    addCheckboxError: function ($checkbox) {
      $checkbox.parents('.checkbox').addClass(classes.checkboxHasError);
    },
    removeCheckboxError: function ($checkbox) {
      $checkbox.parents('.checkbox').removeClass(classes.checkboxHasError);
    },
    validateForm: function () {
      var self = this;
      var formValididation = true;

      // Need an email
      if (!this.$input.val() || this.$input.val().length == 0) {
        this.$input.parents('.form-group').addClass(classes.formGroupHasError);
        formValididation = false;
      }

      // Need all required checkboxes to be checked
      this.$checkboxes.each(function (i, check) {
        var $check = $(check);
        if ($check.is(':required') && !$check.is(":checked")) {
          self.addCheckboxError($check);
          formValididation = false;
        }
      });

      return formValididation;
    },
    onBeforeSend: function() {

      if(this.settings.onBeforeSend() == false) {
        return false;
      }

      if (this.$input.val() && this.$input.val().length) {
        this.$submit.prop('disabled', true);
        return true;
      } else {
        this.$input.parents('.form-group').addClass('alert-info');
      }

      return false;
    },
    onSubmitDone: function(response) {

      this.$submit.prop('disabled', false);

      if(response.success) {
        this.settings.onSubscribeSuccess(response);
      }
      else {
        this.logErrors(response.errors);
        this.settings.onSubscribeFail(response);
      }
    },
    onSubmitFail: function(errors) {

      this.$submit.prop('disabled', false);

      this.logErrors(errors);
      this.settings.onSubmitFail(errors);
    },
    onFormSubmit: function(e) {
      this.$newsletter.trigger('chosen:updated');
      
      e.preventDefault();
      var _this = this;

      $.ajax({
          async: true,
          crossDomain: true,
          url: "//manage.kmail-lists.com/ajax/subscriptions/subscribe",
          method: "POST",
          headers: {
              "content-type": "application/x-www-form-urlencoded",
              "cache-control": "no-cache"
          },
          data: {
              "g": this.settings.listId,
              "$fields": "$source, $newsletter",
              "email": this.$input.val(),
              "$source": this.settings.source,
              "$newsletter": this.$newsletter.find(':selected').val()
          },
          beforeSend: _this.onBeforeSend.bind(_this)
        })
        .done(function(response) {
          _this.onSubmitDone(response);
        })
        .fail(function(jqXHR, textStatus) {
          var errors = [];
          if(jqXHR && jqXHR.responseJSON && jqXHR.responseJSON.hasOwnProperty('errors')) {
            errors = jqXHR.responseJSON.errors;
          }

          _this.onSubmitFail(errors);
        });

      return false;
    },
    onCheckboxClick: function (e) {
      this.removeCheckboxError($(e.currentTarget));
    }
  });

  return AjaxKlaviyoForm;
})(jQuery);

/**
 * Animation Helper Functions / constants
 * -----------------------------------------------------------------------------
 * A collection of functions that help with animations in javascript
 *
 */

slate.animations = (function($) {

  // First add some extra easing equations
  // To add more see the full library - https://github.com/danro/jquery-easing/blob/master/jquery.easing.js
  $.extend( $.easing, {
    // t: current time, b: begInnIng value, c: change In value, d: duration
    easeInQuint: function (x, t, b, c, d) {
      return c*(t/=d)*t*t*t*t + b;
    },
    easeOutQuint: function (x, t, b, c, d) {
      return c*((t=t/d-1)*t*t*t*t + 1) + b;
    },
    easeInOutQuint: function (x, t, b, c, d) {
      if ((t/=d/2) < 1) return c/2*t*t*t*t*t + b;
      return c/2*((t-=2)*t*t*t*t + 2) + b;
    }
  });

  // Match those set in variables.scss
  var _transitionTimingDurations = {
    base:     300,
    fast:     150,
    fastest:  50,
    slow:     600,
    medium:   400,
    none:     0
  };

  var _transitionTimingFunctions = {
    base:      'ease-in-out',
    in:        'ease-out',
    out:       'ease-in',
    inOutUI:   'cubic-bezier(0.42, 0, 0.13, 1.04)'
  };

 /**
  * Get one of the durations stored in the variable defined above
  * If the requested duration doesn't exist, fallback to the base
  *
  * @param {string} key - string matching one of the key names
  * @return {int} - duration in ms
  */
  function getTransitionTimingDuration(key) {
    var k = 'base';
    if(_transitionTimingDurations.hasOwnProperty(key)) {
      k = key;
    }
    return _transitionTimingDurations[k];
  }

 /**
  * Get one of the timing functions stored in the variable defined above
  * If the requested function doesn't exist, fallback to the base
  *
  * @param {string} key - string matching one of the key names
  * @return {string} - valid css timing function
  */
  function getTransitionTimingFunction(key) {
    var k = 'base';
    if(_transitionTimingFunctions.hasOwnProperty(key)) {
      k = key;
    }
    return _transitionTimingFunctions[k];
  }

  return {
    getTransitionTimingDuration: getTransitionTimingDuration,
    getTransitionTimingFunction: getTransitionTimingFunction
  };

}(jQuery));
/**
 * User Scripts
 * -----------------------------------------------------------------------------
 * Mostly handles cookie setting / removal, logic around user sessions
 *
 * @namespace user
 */

slate.user = (function(Cookies) {

  var cookiePrefix = '_sunbum_';

 /**
  * User constructor
  */
  function User() {
    this.name = 'user';
    this.namespace = '.' + this.name;

    // Do any initialization here
    // For instance, you could increment a cookie that tracks visits to the site

    return this;
  }

  User.prototype = $.extend({}, User.prototype, {

   /**
    * Library of cookies to use throughout the site.
    * Use the `generateCookie` method below to create your own copies of these.  Don't access these directly.
    */
    _cookies: {
      siteVisit: {
        name: cookiePrefix + 'site_visit',
        value: true
      },
      subscriptionSlideupSeen: {
        name: 'subscriptionSlideup_seen',
        value: true
      },
      subscriptionModalSeen: {
        name: 'subscriptionModal_seen',
        value: true
      },
      emailCollected: {
        name: 'emailCollected',
        value: true
      }
    },

   /**
    * Creates and returns a copy of one of the cookies available above
    *
    * @param {String} key
    * @return {Object | undefined}
    */
    generateCookie: function(key) {
      var c;
      if(this._cookies.hasOwnProperty(key)) {
        c = $.extend(true, {}, this._cookies[key]);
        c.name = cookiePrefix + c.name;
      }
      else {
        console.warn('['+this.name+'] - Cannot create cookie.  Key "' + key + '" not found.' );
      }
      return c;
    },

   /**
    * Sets a browser cookie
    *
    * @param {Object} cookie
    * @param {String} cookie.name
    * @param {String} cookie.value
    * @param {Number} cookie.expiration - Time to expire in days, expires after session if left blank
    */
    setCookie: function(cookie) {
      if(this.hasCookie(cookie.name) && this.getCookieValue(cookie.name) != cookie.value){
        this.removeCookie(cookie.name);
      }

      var opts = cookie.hasOwnProperty('expiration') ? { expires : cookie.expiration } : {};
      Cookies.set( cookie.name, cookie.value, opts );

      return this;
    },

   /**
    * Checks for the presence of a browser cookie by name (doesn't check for value equality)
    *
    * @param {String} cookieName
    * @return {Boolean}
    */
    hasCookie: function(cookieName) {
      return typeof Cookies.get( cookieName ) !== "undefined";
    },

   /**
    * Returns value of browser cookie by name
    *
    * @param {String} cookieName
    * @return {String | Undefined}
    */
    getCookieValue: function(cookieName) {
      return this.hasCookie( cookieName ) ? Cookies.get( cookieName ) : undefined;
    },

   /**
    * Removes a cookie by name
    *
    * @param {String} cookieName
    * @return {Self}
    */
    removeCookie: function(cookieName) {
      Cookies.remove( cookieName );
      return this;
    }
  });

  return new User();

}(Cookies));

/**
 * Breakpoint Helper Functions / constants
 * -----------------------------------------------------------------------------
 * A collection of functions that help with dealing with site breakpoints in JS
 * All breakpoint properties should be defined here
 *
 */

slate.breakpoints = (function($) {

  var $window = $(window);
  var cachedWindowWidth = $window.width(); 

  // Match those set in variables.scss
  var _breakpointMinWidths = {
    xs: 576,
    sm: 768,
    md: 992,
    lg: 1200,
    xl: 1480
  };

  var events = {
    BREAKPOINT_CHANGE: 'breakpointChange',
  };


 /**
  * Get one of the widths stored in the variable defined above
  *
  * @param {string} key - string matching one of the key names
  * @return {int} - pixel width
  */
  function getBreakpointMinWidth(key) {
    if(!key) return;

    if(_breakpointMinWidths.hasOwnProperty(key)) {
      return _breakpointMinWidths[key];
    }
  }

 /**
  * Gets the key for one of the breakpoint widths, whichever is closest but smaller to the passed in width
  * So if we pass in a width between 'sm' and 'md', this will return 'sm'
  *
  * @param {int} w - width
  * @return {undefined|string} foundKey
  */
  function getBreakpointMinWidthKeyForWidth(w) {
    w = w != undefined ? w : $window.width();
    
    var foundKey;

    $.each(_breakpointMinWidths, function(k, bpMinWidth) {
      if(w >= bpMinWidth) {
        foundKey = k;
      }
    });

    return foundKey;
  }

 /**
  * Triggers a window event when a breakpoint is crossed, passing the new minimum breakpoint width key as an event parameter
  *
  */
  function onResize() {
    var newWindowWidth = $window.width();

    $.each(_breakpointMinWidths, function(k, bpMinWidth) {
      if( (newWindowWidth >= bpMinWidth && cachedWindowWidth < bpMinWidth) || (cachedWindowWidth >= bpMinWidth && newWindowWidth < bpMinWidth) ) {
        
        var bpMinWidthKey = getBreakpointMinWidthKeyForWidth(newWindowWidth);
        var e = $.Event(events.BREAKPOINT_CHANGE, { bpMinWidthKey: bpMinWidthKey });
        $window.trigger(e);
        return false;

      }
    });

    cachedWindowWidth = $window.width();
  }

  $window.on('resize', $.throttle(20, onResize) );

  return {
    getBreakpointMinWidth: getBreakpointMinWidth,
    getBreakpointMinWidthKeyForWidth: getBreakpointMinWidthKeyForWidth
  };

}(jQuery));

/**
 * Product Card Scripts
 * -----------------------------------------------------------------------------
 * Handles any events associated with the product card html (see snippets/product-card.liquid)
 */

slate.productCard = (function() {

  var selectors = {
    el: '[data-product-card]',
    gallery: '[data-product-card-gallery]',
    mainLazyImg: '[data-product-card-main-lazy]',
    altLazyImg: '[data-product-card-alt-lazy]'
  };

  var classes = {
    mainLoaded: 'is-loaded',
    altLoaded: 'alt-loaded' // added to the product card once the alt image is loaded to avoid a flash of white while loading
  };
 
  var events = window.PointerEvent ? {
              end:   "pointerup",
              enter: "pointerenter",
              leave: "pointerleave"
            } : {
              end: "touchend",
              enter: "mouseenter",
              leave: "mouseleave"
            };

  function onEnter(e) {
    var $productCard = $(e.currentTarget);
    var $lazyImg = $productCard.find( selectors.altLazyImg );

    if($lazyImg.length) {
      $lazyImg.on('load', function() {
        $productCard.addClass(classes.altLoaded);
      });
      $lazyImg.attr('src', $lazyImg.data('src'));
      $lazyImg.removeAttr('data-src');
    }
  }

  $(document).ready(function() {

    var $productCards = $(selectors.el);

    if(!$productCards.length) {
      return;
    }

    $productCards.one(events.enter, onEnter);

    // Unveil plugin to lazy load main product card images
    $(selectors.mainLazyImg).unveil(200, function() {
      var $img = $(this);
      $img.on('load', function() {
        $img.parents(selectors.gallery).addClass(classes.mainLoaded);
      });
    });
  });

  

}());
/**
 * Product Detail Form Script
 * ------------------------------------------------------------------------------
 *
 * Handles all functionality related to contents of snippets/product-detail-form.liquid
 * Core functionality includes:
 *  - Variant selecting + callbacks
 *  - Variant galleries + slideshow initializing
 *
 * Requires:
 *  - jQuery
 *  - Modernizr (for Modernizr.touchevents)
 *  - Slate (for slate.Currency)
 */

// Requires slate for slate.Currency

slate.ProductDetailForm = (function($, Modernizr, slate) {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productZoomButton: '[data-zoom-button]',
    productGallery: '[data-product-gallery]',
    productGallerySlideshow: '[data-product-gallery-slideshow]',
    productGallerySlideLink: '[data-product-gallery-slide-link]',
    productGalleryThumbnails: '[data-product-gallery-thumbnails]',
    productGalleryThumbnailsSlide: '[data-product-gallery-thumbnails-slide]',
    initialSlide: '[data-initial-slide]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    singleOptionSelector: '[data-single-option-selector]',
    variantOptionValueList: '[data-variant-option-value-list][data-option-position]',
    variantOptionValue: '[data-variant-option-value]',
    quantitySelect: '[data-product-quantity-select]',
    fullDetailsLink: '[data-full-details-link]',
    videoPlayer: '[data-video-player]'
  };


  var classes = {
    hide: 'hide',
    variantOptionValueActive: 'is-active',
    zoomReady: 'is-zoomable',
    zoomedIn: 'is-zoomed'
  };

  var $window   = $(window);

  /**
   * ProductDetailForm constructor
   *
   * @param { Object } config
   * @param { jQuery } config.$el - Main element, see snippets/product-detail-form.liquid
   * @param { jQuery } config.$container - Container to listen to scope events / element to listen to events on.  Defaults to config.$el
   * @param { Boolean } config.enableZoom - Toggle zoom capabilities on / off
   * @param { Boolean } config.enableHistoryState - If set to "true", turns on URL updating when switching variants
   * @param { Function } config.onReady -  Called after the product form is initialized.
   */
  function ProductDetailForm(config) {

    this.settings = {};
    this.name = 'productDetailForm';
    this.namespace = '.'+this.name;

    this.events = {
      RESIZE: 'resize' + this.namespace,
      CLICK:  'click'  + this.namespace,
      READY:  'ready'  + this.namespace
    };

    var ready = false;
    var options = options || {};
    var defaults = {
      enableZoom: true,
      enableHistoryState: true
    };

    this.initialize = function() {
      if(ready) {
        return;
      }

      this.settings = $.extend({}, defaults, config);

      if (!this.settings.$el || this.settings.$el == undefined) {
        console.warn('['+this.name+'] - $el required to initialize');
        return;
      }

      this.$el = this.settings.$el;
      this.$container = this.settings.$container;

      if (!this.$container || this.$container == undefined) {
        this.$container = this.$el;
      }

      this.productSingleObject  = JSON.parse($(selectors.productJson, this.$container).html());

      slate.utils.chosenSelects(this.$container);

      var variantOptions = {
        $container: this.$container,
        enableHistoryState: this.settings.enableHistoryState,
        singleOptionSelector: selectors.singleOptionSelector,
        originalSelectorId: selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(variantOptions);

      // See slate.Variants
      this.$container.on('variantChange' + this.namespace, this.onVariantChange.bind(this));

      this.initGalleries();

      this.$container.on(this.events.CLICK, selectors.variantOptionValue, this.onVariantOptionValueClick.bind(this));

      var e = $.Event(this.events.READY);
      this.$el.trigger(e);

      ready = true;
    };

    return this;
  }

  ProductDetailForm.prototype = $.extend({}, ProductDetailForm.prototype, {

    initGalleries: function() {
      var self = this;
      var $galleries = $(selectors.productGallery, this.$container);

      var ambassadorCardParent = this.$container.closest($(".product-card--ambassador"));

      if (ambassadorCardParent.length > 0) {
        hasAmbassadorCardParent = true;
      } else {
        hasAmbassadorCardParent = false;
      }

      // Lifecycle methods for handling slideshow changes + hoverzoom initialization
      function initHoverZoom($zoomTarget) {
        var opts = {
          url: $zoomTarget.find(selectors.productGallerySlideLink).attr('href'),
          on: 'click',
          touch: false,
          escToClose: true,
          magnify: 0.8,
          duration: 300,
          callback: function() {
            $zoomTarget.addClass(classes.zoomReady);
          },
          onZoomIn: function() {
            $zoomTarget.addClass(classes.zoomedIn);
            $zoomTarget.find(selectors.productGallerySlideLink).hide();
          },
          onZoomOut: function() {
            $zoomTarget.removeClass(classes.zoomedIn);
            $zoomTarget.find(selectors.productGallerySlideLink).show();
          }
        };

        $zoomTarget.zoom(opts);

        $zoomTarget.find(selectors.productZoomButton).on('click', function(e){
          $zoomTarget.trigger('click');
          return false;
        });

      }

      function destroyHoverZoom($zoomTarget) {
        $zoomTarget.trigger('zoom.destroy');
        $zoomTarget.find(selectors.productZoomButton).off('click');
      }

      function onSlideshowSlickBeforeChange(e, slick) {
        var $zoomTarget = $(slick.$slides[ slick.currentSlide ]);
        if(self.settings.enableZoom) {
          destroyHoverZoom($zoomTarget);
        }
        slate.videoPlayer.pauseVideosInContainer($(slick.$slides[ slick.currentSlide ]));
      }

      function onSlideshowSlickAfterChange(e, slick) {
        var $zoomTarget = $(slick.$slides[ slick.currentSlide ]);
        if(self.settings.enableZoom) {
          initHoverZoom($zoomTarget);
        }
      }

      function onSlideshowSlickInit(e, slick) {
        var $zoomTarget = $(slick.$slides[ slick.currentSlide ]);
        if(self.settings.enableZoom) {
          initHoverZoom($zoomTarget);
        }
        
        slate.videoPlayer.reInitVideoPlayers();
      }

      $galleries.each(function() {
        var $slideshow  = $(this).find(selectors.productGallerySlideshow);
        var $thumbnails = $(this).find(selectors.productGalleryThumbnails);

        // Look for element with the initialSlide selector.
        var initialSlide = $(this).find(selectors.initialSlide).length ? $(this).find(selectors.initialSlide).index() : 0;

        var thumbnailsSlidesToShow;
        var thumbnailsSlidesCount = $thumbnails.children().length;
        var hasThumbnailSlideshow = thumbnailsSlidesCount > 4 ? true : false;

        // Slick has trouble when slideToShow == slideCount
        if (thumbnailsSlidesCount < 4) {
          thumbnailsSlidesToShow = Math.max(thumbnailsSlidesCount - 1, 1);
        } else {
          thumbnailsSlidesToShow = thumbnailsSlidesCount == 4 ? 3 : 4;
        }
        
        if (hasAmbassadorCardParent) {
          thumbnailsSlidesToShow = 4;
          $thumbnails.addClass('product-gallery__thumbnails-wrapper--is-ambassador');
        }
        
        $slideshow.on({
          init: onSlideshowSlickInit,
          beforeChange: onSlideshowSlickBeforeChange,
          afterChange: onSlideshowSlickAfterChange
        });
        var slideshowOptions = {
          speed: 600,
          dots: (thumbnailsSlidesCount > 1 ? true : false),
          arrows: false,
          infinite: false,
          swipe: Modernizr.touchevents,
          initialSlide: initialSlide,
          accessibility: false,
          draggable: true,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                arrows: true,
                appendDots: $('.product-gallery--mobile__dots'),
                nextArrow: $('.product-gallery--mobile__arrow-next'),
                prevArrow: $('.product-gallery--mobile__arrow-prev')
              }
            }
          ]
        };
        if (hasThumbnailSlideshow) {
          slideshowOptions.asNavFor = "#" + $thumbnails.attr("id");
        }
        $slideshow.slick(slideshowOptions);

        if (thumbnailsSlidesCount > 4) {
          $thumbnails.slick({
            speed: 600,
            slidesToShow: thumbnailsSlidesToShow,
            slidestoScroll: 1,
            infinite: false,
            arrows: thumbnailsSlidesCount > 4 ? true : false,
            prevArrow: $('.product-gallery__thumbnails-arrow--prev'),
            nextArrow: $('.product-gallery__thumbnails-arrow--next'),
            asNavFor: "#" + $slideshow.attr("id"),
            initialSlide: initialSlide,
            accessibility: false,
            draggable: false,
            vertical: true,
            verticalSwiping: true,
            dots: false
          });
          
          $thumbnails.addClass('product-gallery__thumbnails-wrapper--has-arrows');
        } else {
          $('.product-gallery__thumbnails-arrow').hide();
        }

        $thumbnails.on('click', selectors.productGalleryThumbnailsSlide, function(e) {
          $slideshow.slick('slickGoTo', $(e.currentTarget).index() );
        });

      });

      // Because slick can get weird on initialization, make sure we call `refresh` on any visible galleries
      $galleries.not('.hide').each(function() {
        var $variantGallery = $(this);
        $variantGallery.find(selectors.productGallerySlideshow).slick('getSlick').refresh();

        var $thumbnails = $(
          selectors.productGalleryThumbnails,
          $variantGallery
        )
        var hasThumbnailSlideshow = $thumbnails.length > 4 ? true : false;
        if (hasThumbnailSlideshow) {
          $variantGallery.find(selectors.productGalleryThumbnails).slick('getSlick').refresh();
        }
      });
    },

    /**
     * Slick sliders are annoying and sometimes need an ass kicking
     *
     */
    resizeGalleries: function() {
      $('.slick-slider', this.$container).resize();
    },
    

    onVariantChange: function(evt) {
      var variant = evt.variant;

      this.updateProductPrices(variant);
      this.updateAddToCartState(variant);
      this.updateQuantityDropdown(variant);
      this.updateVariantOptionValues(variant);
      this.updateFullDetailsLink(variant);
      this.updateGalleries(variant);

      $(selectors.singleOptionSelector, this.$container).trigger('chosen:updated');
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {Object} variant - Shopify variant object
     */
    updateAddToCartState: function(variant) {

      var $addToCartBtn     = $(selectors.addToCart, this.$container);
      var $addToCartBtnText = $(selectors.addToCartText, this.$container);
      var $priceWrapper     = $(selectors.priceWrapper, this.$container);

      if (variant) {
        $priceWrapper.removeClass(classes.hide);
      } else {
        $addToCartBtn.prop('disabled', true);
        $addToCartBtnText.html(theme.strings.unavailable);
        $priceWrapper.addClass(classes.hide);
        return;
      }

      if (variant.available) {
        $addToCartBtn.prop('disabled', false);
        $addToCartBtnText.html(theme.strings.addToCart);
      } else {
        $addToCartBtn.prop('disabled', true);
        $addToCartBtnText.html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the disabled property of the quantity select based on the availability of the selected variant
     *
     * @param {Object} variant - Shopify variant object
     */
    updateQuantityDropdown: function(variant) {

      var $select = $(selectors.quantitySelect, this.$container);

      // Close the dropdown while we make changes to it
      $select.trigger('chosen:close');

      if(variant && variant.available) {
        $select.prop('disabled', false);
      }
      else {
        $select.prop('disabled', true);
      }

      $select.trigger('chosen:updated');

    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {Object} variant - Shopify variant object
     */
    updateProductPrices: function(variant) {
      var $productPrice = $(selectors.productPrice, this.$container);
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls   = $comparePrice.add( $(selectors.comparePriceText, this.$container) );

      if(variant) {
        $productPrice.html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

        if (variant.compare_at_price > variant.price) {
          $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
          $compareEls.removeClass(classes.hide);
        } else {
          $comparePrice.html('');
          $compareEls.addClass(classes.hide);
        }
      }
    },

    /**
     * Updates the DOM state of the elements matching the variantOption Value selector based on the currently selected variant
     *
     * @param {Object} variant - Shopify variant object
     */
    updateVariantOptionValues: function(variant) {
      if(variant) {
        // Loop through all the options and update the option value
        for (var i = 1; i <= 3; i++) {
          var variantOptionValue = variant['option' + i];

          if(!variantOptionValue) break; // Break if the product doesn't have an option at this index

          // Since we are finding the variantOptionValueUI based on the *actual* value, we need to scope to the correct list
          // As some products can have the same values for different variant options (waist + inseam both use "32", "34", etc..)
          var $variantOptionValueList = $(selectors.variantOptionValueList, this.$container).filter('[data-option-position="'+i+'"]');
          var $variantOptionValueUI = $('[data-variant-option-value="'+variantOptionValue+'"]', $variantOptionValueList);

          $variantOptionValueUI.addClass( classes.variantOptionValueActive );
          $variantOptionValueUI.siblings().removeClass( classes.variantOptionValueActive );
        }
      }
    },

    /**
     * Used on quick view, updates the "view full details" link to point to the currently selected variant
     *
     * @param {Object} variant - Shopify variant object
     */
    updateFullDetailsLink: function(variant) {
      var $fullDetailsLink = $(selectors.fullDetailsLink, this.$container);
      var updatedUrl;

      if(variant && $fullDetailsLink.length) {
        updatedUrl = slate.utils.getUrlWithUpdatedQueryStringParameter('variant', variant.id, $fullDetailsLink.attr('href'));
        $fullDetailsLink.attr('href', updatedUrl);
      }
    },

    /**
     * Look for a gallery matching one of the selected variant's options and switch to that gallery
     * If a matching gallery doesn't exist, look for the variant's featured image in the main gallery and switch to that
     *
     * @param {Object} variant - Shopify variant object
     */
    updateGalleries: function(variant) {

      var $galleries = $(selectors.productGallery, this.$container);

      function getVariantGalleryForOption(option) {
        return $galleries.filter(function() {
          return $(this).data('variant-gallery') == option;
        });
      }

      if (variant) {
        if ($galleries.length > 1) {
          for (var i = 3; i >= 1; i--) {
            var $variantGallery = getVariantGalleryForOption(variant['option' + i]);

            if ($variantGallery.length && $variantGallery.hasClass(classes.hide)) {
              $galleries.not($variantGallery).addClass(classes.hide);
              $variantGallery.removeClass(classes.hide);
              // Slick needs to make a lot of measurements in order to work, calling `refresh` forces this to happen
              $variantGallery.find(selectors.productGallerySlideshow).slick('getSlick').refresh();
              // $variantGallery.find(selectors.productGalleryThumbnails).slick('getSlick').refresh();
            }
          }
        }
        else {
          // $galleries is just a single gallery
          // Slide to featured image for selected variant but only if we're not already on it.
          // Have to check this way because slick clones slides so even if we're currently on it, there can be a cloned slide that also has the correct data-image attribute
          if (variant.featured_image && $galleries.find('.slick-current').data('image') != variant.featured_image.id) {
            var $imageSlide = $galleries.find('[data-image="'+variant.featured_image.id+'"]').first();

            if ($imageSlide.length) {
              $galleries.find(selectors.productGallerySlideshow).slick('slickGoTo', $imageSlide.data('slick-index'));
            }
          }
        }
      }
      else {
        // No variant - Don't do anything?
      }
    },

    /**
     * Handle variant option value click event.
     * Update the associated select tag and update the UI for this value
     *
     * @param {event} evt
     */
    onVariantOptionValueClick: function(e) {

      var $option = $(e.currentTarget);

      if ($option.hasClass(classes.variantOptionValueActive)) {
        return;
      }

      var value     = $option.data('variant-option-value');
      var position  = $option.parents(selectors.variantOptionValueList).data('option-position');
      var $selector = $(selectors.singleOptionSelector, this.$container).filter('[data-index="option'+position+'"]');

      $selector.val(value);
      $selector.trigger('change');

      $option.addClass(classes.variantOptionValueActive);
      $option.siblings().removeClass( classes.variantOptionValueActive );

    }
  });

  return ProductDetailForm;

})(jQuery, Modernizr, slate);

/**
 * QuickView
 * -----------------------------------------------------------------------------
 * Initializes the quickview feature by listening for click events and signaling the quickview manager to take action
 *
 */

slate.quickView = (function() {

  var $window = $(window);
  var $body = $(document.body);

  var selectors = {
    quickViewTrigger: '[data-quick-view-trigger]',
    productCard: '[data-product-card]'
  };

  /**
   * QuickViewManager 
   *
   * - Creates and keeps track of quickviews on the page.
   * - Makes sure only one is visible at a time and that we only load a quick view *once* per product card
   *
   * @constructor
   */
  function QuickViewManager() {
    this.name = 'quickViewManager';
    this.quickViews = [];

    var isLoadingQuickView = false;

    this.register = function(qv) {
      if( !(qv instanceof slate.models.QuickView) ) {
        console.warn('['+this.name+'] - instance of slate.models.QuickView required when calling register');
        return;
      }

      this.quickViews.push(qv);

      return this;
    };

    this.getQuickViewByProductCard = function($productCard) {
      var foundQV;

      $.each(this.quickViews, function(i, qv) {
        if( qv.$productCard.is($productCard) ) {
          foundQV = qv;
          return false;
        }
      });

      return foundQV;
    };

    this.onResize = function() {
      $.each(this.quickViews, function(i, qv){
        qv.onResize();
      });
    };

    this.getOpenQuickViews = function() {
      var opens = [];

      $.each(this.quickViews, function(i, qv) {
        qv.isOpen() && opens.push(qv);
      });

      return opens;
    },

    this.closeOpenQuickViews = function(cb) {
      var opens = this.getOpenQuickViews();

      if(opens.length == 0 ) {
        cb();
      }
      else {
        $.each(opens, function(i, qv) {
          if(i==0) {
            qv.$productCard.one('closed.quickView', cb);  
          }
          qv.close();
        });
      }

    };

    this.onQuickViewTriggerClick = function($trigger) {
      if($trigger == undefined) {
        return;
      }

      var quickViewManager = this;
      var $productCard     = $trigger.parents(selectors.productCard);
      var quickView        = this.getQuickViewByProductCard($productCard);
      var triggerText      = $trigger.text(); // Cache this text so we can set it as loading

      if(quickView == undefined) {

        if(isLoadingQuickView) return; // Return early, we're already fetching a quick view, sorry!

        isLoadingQuickView = true;

        $trigger.text('Loading');

        // generate a new QV
        quickView = new slate.models.QuickView({
          $productCard: $productCard,
          url: $trigger.attr('href'),
          transitionDuration: slate.animations.getTransitionTimingDuration('slow'),
          transitionTimingFunction: slate.animations.getTransitionTimingFunction('inOutUI')
        });

        $productCard.one('loaded.quickView', function() {
          isLoadingQuickView = false;
          $trigger.text(triggerText); // Return the button to it's original state
          quickViewManager.closeOpenQuickViews( quickView.open.bind(quickView) ); // Make sure all the QVs are closed before opening this new one
          slate.quantityAdjuster.refresh();
        });

        quickViewManager.register(quickView);
      }
      else {
        if(!quickView.isOpen()) {
          quickViewManager.closeOpenQuickViews( quickView.open.bind(quickView) );  
        }
      }
    };

    $window.on('resize', $.throttle(50, this.onResize.bind(this)));

    return this;
  }

  var quickViewManager = new QuickViewManager();  

  $(function() {

    $body.on('click', selectors.quickViewTrigger, function(e) {
      e.preventDefault();
      quickViewManager.onQuickViewTriggerClick($(this));
    });
    
  });

}());

/**
 * Quantity Adjuster Scripts
 * -----------------------------------------------------------------------------
 * Handles any events associated with the quantity adjuster component
 *
 *  [data-quantity-adjuster]
 *    [data-increment]
 *    input[type="number"]
 *    [data-decrement]
 *
 */

slate.quantityAdjuster = (function() {

  var selectors = {
    adjuster: '[data-quantity-adjuster]',
    increment: '[data-increment]',
    decrement: '[data-decrement]',
    input: 'input[type="number"]'
  };

  var classes = {

  };

  /**
   * Quantity Adjuster Constructor
   *
   * @param {HTMLElement | jQuery} el - element, either matching selectors.adjuster or a child element
   */
  function QuantityAdjuster(el) {

    this.name = 'quantityAdjuster',
    this.namespace = '.'+this.name;

    this.$el = $(el).is(selectors.adjuster) ? $(el) : $(el).parents(selectors.adjuster);

    if(!this.$el) {
      console.warn('['+this.name+'] - Element required to initialize');
      return;
    }

    this.$increment = $(selectors.increment, this.$el);
    this.$decrement = $(selectors.decrement, this.$el);
    this.$input     = $(selectors.input, this.$el);

    this.$increment.on('click', this.onIncrementClick.bind(this));
    this.$decrement.on('click', this.onDecrementClick.bind(this));
    this.$input.on('change', this.onInputChange.bind(this));

    this._addMutationObserver(this.$input.get(0));

    this._updateDisabledState();
  }

  QuantityAdjuster.prototype = {

    _getMin: function() {
      return parseInt(this.$input.attr('min')) || 0;
    },

    _getMax: function() {
      return parseInt(this.$input.attr('max')) || 999;
    },

    _addMutationObserver: function(el) {
      if(!el) return;

      var observer;
      var config = { attributes: true };
      var self = this;

      observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if(mutation.type == "attributes") {
            if(mutation.attributeName == "max" || mutation.attributeName == "min") {
              self.onMinMaxAttributeChange();
            }
            else if(mutation.attributeName == "disabled") {
              self.onDisabledAttributeChange();
            }
          }
        });
      });

      observer.observe(el, config);
    },

    _updateDisabledState: function() {
      var val = parseInt(this.$input.val());

      if(this.$input.is(':disabled')) {
        this.$increment.prop('disabled', true);
        this.$decrement.prop('disabled', true);
      }
      else {
        if (val == this._getMax() && val == this._getMin()) {
          this.$increment.prop('disabled', true);
          this.$decrement.prop('disabled', true);
        }
        else if(val >= this._getMax()) {
          this.$increment.prop('disabled', true);
          this.$decrement.prop('disabled', false);
        }
        else if(val <= this._getMin()) {
          this.$increment.prop('disabled', false);
          this.$decrement.prop('disabled', true);
        }
        else {
          this.$increment.prop('disabled', false);
          this.$decrement.prop('disabled', false);
        }
      }
    },

    _changeValue: function(amount) {

      if(this.$input.is(':disabled') || typeof amount == "undefined") return;

      amount = parseInt(amount);

      var val = parseInt(this.$input.val());
      var newVal = val + amount;

      // Don't change if the value is the same or invalid
      if(newVal == val || newVal > this._getMax() || newVal < this._getMin()) return;

      this.$input.val(newVal);
      this.$input.trigger('change');
    },

    _clampInputVal: function() {
      var currVal = parseInt(this.$input.val());
      var max = this._getMax();
      var min = this._getMin();

      if(currVal > max) {
        this.$input.val(max);
      }
      else if(currVal < min) {
        this.$input.val(min);
      }
    },

    onDisabledAttributeChange: function() {
      this._updateDisabledState();
    },

    onMinMaxAttributeChange: function() {
      this._clampInputVal();
      this._updateDisabledState();
    },

    onInputChange: function() {
      this._clampInputVal();
      this._updateDisabledState();
    },

    onIncrementClick: function(e) {
      e.preventDefault();
      this._changeValue(1);
    },

    onDecrementClick: function(e) {
      e.preventDefault();
      this._changeValue(-1);
    }
  };

  // End prototype

  // QA DATA-API
  // ===========

  var dataKey = 'quantity-adjuster';

  function ensureQuantityAdjuster(el) {
    var $el =  $(el);

    if(!$el.is(selectors.adjuster)) {
      $el = $el.parents(selectors.adjuster);
    }

    var data = $el.data(dataKey);

    if(!data) {
      $el.data(dataKey, (data = new QuantityAdjuster($el)));
    }

    return data;
  }

  // Check all adjuster elements on the page and initialize them if necessary
  function refresh() {
    $(selectors.adjuster).each(function(i, el) {
      ensureQuantityAdjuster(el);
    });
  }

  $(function() {

    refresh();

    $(document)
      .on('shopify:section:load', refresh)
      .on('shopify:section:unload', refresh)
      .on('shopify:section:select', refresh)
      .on('shopify:section:deselect', refresh)
      .on('shopify:section:reorder', refresh)
      .on('shopify:block:select', refresh)
      .on('shopify:block:deselect', refresh);
  });

  return {
    refresh: refresh
  };

}());

/**
 * Forms Scripts
 * -----------------------------------------------------------------------------
 * Handles any events associated with forms on the site
 */

slate.forms = (function($) {

  var selectors = {
    formControl: '.form-control',
    formGroup: '.form-group',
    chosen: '.chosen-container'
  };

  var classes = {
   formGroupIsFocused: 'is-focused',
   formGroupHasError: 'has-error'
  };

  var $body = $(document.body);
 
  var initialized = false;

  function onFormControlFocus(e) {
    var $formControl = $(e.currentTarget);
    var $formGroup   = $formControl.parents(selectors.formGroup);

    $formGroup.addClass(classes.formGroupIsFocused);
  }

  function onFormControlBlur(e) {
    var $formControl = $(e.currentTarget);
    var $formGroup   = $formControl.parents(selectors.formGroup);

    $formGroup.removeClass(classes.formGroupIsFocused);    
  }

  function removeFormControlErrorState(e) {
    var $formControl = $(e.currentTarget);
    var $formGroup   = $formControl.parents(selectors.formGroup);

    $formGroup.removeClass(classes.formGroupHasError);
  }

  function onChosenShowingDropdown(e) {
    onFormControlFocus(e);
  }

  function onChosenHidingDropdown(e) {
    onFormControlBlur(e);
  }

  function initialize() {
    if(initialized) return;

    $body.on('focus', selectors.formControl, onFormControlFocus);
    $body.on('blur',  selectors.formControl, onFormControlBlur);
    $body.on('change keydown', selectors.formControl, removeFormControlErrorState);
    $body.on('chosen:showing_dropdown', selectors.formControl, onChosenShowingDropdown);
    $body.on('chosen:hiding_dropdown', selectors.formControl, onChosenHidingDropdown);

    initialized = true;
    
    return initialized;
  }

  return {
    initialize: initialize
  };

}(jQuery));
/**
 * Video Player Script
 * -----------------------------------------------------------------------------
 *
 * Creates a YouTube player out of basic markup
 * Requires some basic styling to make things work correctly - see components/video-player.scss
 *
 * Mark up looks like...
 *
    <div id="video-player-{{ yt_video_id }}" class="video-player" data-video-id="{{ yt_video_id }}" data-video-type="vimeo / youtube" data-video-player>
      <a href="#"  class="video-player__cover" data-video-player-cover>
        <div class="video-player__cover-still" style="background-image: url(...);"></div>
        <span class="video-player__cover-play">{% include 'icon-play-button' %}</span>
      </a>
      <div class="video-player__embed" data-video-player-embed></div>
    </div>
 *
 */

slate.videoPlayer = (function($, Vimeo) {

  var selectors = {
    videoPlayer: '[data-video-player]',
    videoPlayerEmbed: '[data-video-player-embed]',
    videoPlayerCover: '[data-video-player-cover]',
    youtubeVideo: '.video-player__embed'
  };

  var classes = {
    state: {
      playing:  'video-player--playing',
      finished: 'video-player--finished',
      paused:   'video-player--paused',
    }
  };

  function VideoPlayer(el) {
    this.name = 'videoPlayer',
    this.namespace = '.'+this.name;

    this.$el = $(el);

    if(!this.$el.is(selectors.videoPlayer)) {
      console.warn('['+this.name+'] - Element matching ' + selectors.videoPlayer + ' required to initialize');
      return;
    }

    this.VIDEO_TYPES = {
      VIMEO: 'vimeo',
      YOUTUBE: 'youtube'
    };

    this.player    = null;
    this.state     = null;
    this.videoType = this.$el.data('video-type').toLowerCase();
    this.videoId   = this.$el.data('video-id');
    this.background = this.$el.data('background');

    if(!this.videoId || !(this.videoType == "vimeo" || this.videoType == "youtube") ) {
      console.warn('['+this.name+'] - Video ID and valid video type required to initialize');
      return;
    }

    this.$embed = this.$el.find(selectors.videoPlayerEmbed);
    this.$cover = this.$el.find(selectors.videoPlayerCover);
    this.$cover.attr('title', 'Click to play');

    // We bind vimeo videos up front because the API can't be loaded async
    // So it's already on the page
    // And it does a weird thing where it pauses if you play immediately after ready
    if(this.videoType == this.VIDEO_TYPES.VIMEO) {
      this.bindVimeoPlayer();
    }

    this.$cover.on('click', this.onCoverClick.bind(this));
  }

  VideoPlayer.prototype = {

    _getClassForCurrentState: function() {
      if(this.state && classes.state.hasOwnProperty(this.state)) {
        return classes.state[this.state];
      }
    },

    bindVimeoPlayer() {
      const opts = {
        id: this.videoId,
        color: '00A4E3' // brand primary
      };

      opts.background = this.background || false;
      opts.muted      = this.background;
      opts.autoplay   = this.background;

      this.player = new Vimeo.Player(this.$embed, opts);

      this.player.on('ended', this.onEnded.bind(this));
      this.player.on('play',  this.onPlay.bind(this));
      this.player.on('pause', this.onPaused.bind(this));
      this.player.on('bufferstart', this.onBuffering.bind(this));

      if (!this.background && !this.$cover.length ) {
        this.$cover.on('click', this.onCoverClick.bind(this));
      }
    },

    switchToState(state) {
      this.$el.removeClass(classes.state[this.state]);
      this.$el.addClass(classes.state[state]);
      
      this.state = state;
    },

    onPlay() {
      this.switchToState('playing');
    },

    onEnded() {
      this.switchToState('ended');
    },

    onPaused() {
      this.switchToState('paused');
    },

    onBuffering() {
      this.switchToState('buffering');
    },

    bindYTPlayer: function() {
      var self = this;
      var uniqID = this.$el.attr('id') + '-player';

      this.$embed.attr('id', uniqID);
      this.player = new YT.Player(uniqID, {
          videoId: this.videoId,
          playerVars: {
            rel: 0,
            autohide: 1,
            controls: 2,
            playsinline: 1,
            modestbranding: 1,
            wmode: "transparent",
          },
          events: {
            onReady: function(e) {
              e.target.playVideo();
            },
            onStateChange: function(e) {
              switch (e.data) {
              case YT.PlayerState.PLAYING:
                  self.onPlaying();
                  break;
              case YT.PlayerState.PAUSED:
                  self.onPaused();
                  break;
              case YT.PlayerState.ENDED:
                  self.onFinished();
              }
            }
          }
        });

      window.videoList = window.videoList || [];

      window.videoList.push({
        dataKey: this.videoId,
        player: this
      });
    },

    switchToState: function(state) {
      this.$el.removeClass( this._getClassForCurrentState());

      this.state = state;

      this.$el.addClass(this._getClassForCurrentState());
    },

    play: function() {
      if(this.videoType == this.VIDEO_TYPES.YOUTUBE) {
        this.player.playVideo();
      }
      else if (this.videoType == this.VIDEO_TYPES.VIMEO) {
        this.player.play().then(this.onPlaying.bind(this));
      }
    },

    pause: function() {
      if(this.videoType == this.VIDEO_TYPES.YOUTUBE) {
        this.player.pauseVideo();
      }
      else if (this.videoType == this.VIDEO_TYPES.VIMEO) {
        this.player.pause().then(this.onPaused.bind(this));
      }
    },


    onPlaying: function() {
      this.switchToState('playing');
    },

    onFinished: function() {
      this.switchToState('finished');
    },

    onPaused: function() {
      this.switchToState('paused');
    },

    onCoverClick: function(e) {
      e.preventDefault();

      if(this.player) {
        this.play();
      }
      else {

        if(this.videoType == this.VIDEO_TYPES.YOUTUBE) {
          if(typeof window.YT == "undefined") {

            window.onYouTubeIframeAPIReady = this.bindYTPlayer.bind(this);

            var tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
          }
          else {
            this.bindYTPlayer();
          }
        }
        // else if (this.videoType == this.VIDEO_TYPES.VIMEO) {
        //   this.bindVimeoPlayer();
        // }
      }

      return false;
    }
  };

  // DATA-API
  // ========

  var dataKey = 'video-player-instance';

  $(function() {
    $(selectors.videoPlayer).each(function(i, el) {
      var $el =  $(el);

      var data = $el.data(dataKey);

      if(!data) {
        $el.data(dataKey, (data = new VideoPlayer($el)));
      }

      window.videoList = window.videoList || [];

      window.videoList.push({
        dataKey: $el.data('video-id'),
        player: data
      })

      return data;
    });
  });


  // Returned Module
  return {
    getDataKey: function() {
      return dataKey;
    },
    reInitVideoPlayers: function() {
      $(selectors.videoPlayer).each(function(i, el) {
        var $el =  $(el);
  
        var data = $el.data(dataKey);
  
        if(!data) {
          $el.data(dataKey, (data = new VideoPlayer($el)));
        }
  
        return data;
      });
    },
    pauseVideosInContainer: function($el) {
      $el.find(selectors.videoPlayer).each(function(index, videoContainer) {
        var videoId = $(videoContainer).data('video-id');
        $.each(window.videoList, function(index, val) {
           if (val.dataKey === videoId) {
            val.player.pause();
           }
        });

      });
    }
  };

}(jQuery, Vimeo));

/**
 * Model - Dropdown
 * -----------------------------------------------------------------------------
 * Dropdowns are just elements that respond to a visibility class in order to hide and show
 *
 * @namespace models.dropdown
 */

 slate.models = slate.models || {};

 slate.models.Dropdown = (function($) {

  var classes = {
    open: 'is-open',
    forcedOpen: 'is-forced-open'
  };

  /**
   * Dropdown - Exposes methods for opening and closing the dropdown.  All logic is handled externally
   *
   * @constructor
   * @param {jQuery} $trigger - Element with attributes 'data-dropdown-trigger' and 'data-block'
   */
  function Dropdown($trigger) {
    this.$trigger = $trigger;
    this.$el      = $( this.$trigger.data('dropdown-trigger') );
    this.blockId  = this.$trigger.data('block').toString();
  }

  Dropdown.prototype = {

    isOpen: function() {
      return this.$el.hasClass( classes.open );
    },

    open: function() {
      this.$el.addClass( classes.open );
      this.$trigger.addClass(classes.open);
    },

    close: function() {
      this.$el.removeClass( classes.open );
      this.$trigger.removeClass(classes.open);
    },

    /**
     * Dropdown manager doesn't use the forced open class
     * So we can use it in conjunction with the theme editor to ensure dropdowns are open while editing
     */
    forceOpen: function() {
      this.$el.addClass( classes.forcedOpen );
    },

    forceClose: function() {
      this.$el.removeClass( classes.forcedOpen );
    }

  };

  return Dropdown;

 }(jQuery));
/**
 * Model - DropdownManager
 * -----------------------------------------------------------------------------
 *
 * Requires:
 *  - slate.models.Dropdown
 *  - slate.utils
 *
 * @namespace models.DropdownManager
 */

 slate.models = slate.models || {};

 slate.models.DropdownManager = (function($) {

  /**
   * DropdownManager - Manages opening / closing of all dropdowns.  Makes sure only one shows at a time.
   *
   * @constructor
   * @param {function} dropdownConstructor
   */
  function DropdownManager() {

    this.closeDropdownTimeout = null;
    this.closeDropdownTimeoutDuration = 80;
    this.dropdowns = [];
    this.activeDropdown = undefined;

    this.events = window.PointerEvent ? {
                  end:   "pointerup",
                  enter: "pointerenter",
                  leave: "pointerleave"
                } : {
                  end: "touchend",
                  enter: "mouseenter",
                  leave: "mouseleave"
                };

  }

  DropdownManager.prototype = {
    register: function($trigger) {
      var dd = new slate.models.Dropdown($trigger);

      // Trigger events - the link that you interact with to display the dropdown
      dd.$trigger.on(this.events.enter,  this.onTriggerMouseEnter.bind(this, dd));
      dd.$trigger.on(this.events.leave,  this.onTriggerMouseLeave.bind(this, dd));
      dd.$trigger.on(this.events.end,    this.onTriggerTouchEnd.bind(this, dd));

      // Dropdown events - what happens when you interact with the dropdown itself
      dd.$el.on(this.events.leave, this.onDropdownMouseLeave.bind(this, dd));
      dd.$el.on(this.events.enter, this.onDropdownMouseEnter.bind(this, dd));
      dd.$el.on(this.events.end,   this.onDropdownTouchEnd.bind(this, dd));

      this.dropdowns.push(dd);
    },    
    getDropdownByBlockId: function(id) {
      return slate.utils.findInstance(this.dropdowns, 'blockId', id);
    },
    onTriggerMouseEnter: function(dd, e) {
      if(e.pointerType != "touch") {
        this.stopCloseTimeout();
        this.openDropdown(dd);
      }
    },
    onTriggerMouseLeave: function(dd, e) {
      if(e.pointerType != "touch") {
        this.startCloseTimeout(dd);
      }
    },
    onTriggerTouchEnd: function(dd, e) {
      e.preventDefault();
      e.stopPropagation();
      this.toggleDropdown(dd);
    },
    onDropdownMouseEnter: function(dd, e) {
      if(e.pointerType != "touch") {
        this.stopCloseTimeout();
      }
    },
    onDropdownMouseLeave: function(dd, e) {
      if(e.pointerType != "touch") {
        this.startCloseTimeout(dd);
      }
    },
    onDropdownTouchEnd: function(dd, e) {
      e.stopPropagation();
    },
    toggleDropdown: function(dd) {
      return this.activeDropdown == dd ? this.closeDropdown(dd) : this.openDropdown(dd);
    },
    openDropdown: function(dd) {
      if(this.activeDropdown !== dd) {
        this.activeDropdown = dd;
        this.closeAllDropdowns();
        dd.open();
      }
    },
    closeDropdown: function(dd) {
      dd.close();

      if(this.activeDropdown == dd) {
        this.activeDropdown = undefined;
      }
    },
    closeAllDropdowns: function() {
      $.each(this.dropdowns, function(i, dd) {
        if(dd.isOpen()) {
          dd.close();
        }
      });
      this.activeDropdown = undefined;
    },
    startCloseTimeout: function(dd) {
      this.closeDropdownTimeout = setTimeout(this.closeDropdown.bind(this, dd), this.closeDropdownTimeoutDuration);
    },
    stopCloseTimeout: function() {
      clearTimeout(this.closeDropdownTimeout);
    }
  };

  return DropdownManager;

 }(jQuery));
/**
 * Drawer
 * ------------------------------------------------------------------------------
 *
 * Requires:
 *  - Modernizr
 *
 * @namespace - models.Drawer
*/

slate.models = slate.models || {};

slate.models.Drawer = (function($, Modernizr) {

  var $document = $(document);
  var $body     = $(document.body);

  var selectors = {
    close: '[data-drawer-close]',
    mobileSearch: '[data-mobile-search]'
  };

  var classes = {
    drawer: 'drawer',
    visible: 'is-visible',
    backdrop: 'drawer-backdrop',
    backdropVisible: 'is-visible',
    bodyDrawerOpen: 'drawer-open'    
  };

 /**
  * Drawer constructor
  *
  * @param {HTMLElement | $} el - The drawer element
  * @param {Object} options
  */
  function Drawer(el, options) {

    this.name = 'drawer';
    this.namespace = '.'+this.name;

    this.$el = $(el);
    this.$backdrop              = null;
    this.stateIsOpen            = false;
    this.transitionEndEvent     = slate.utils.whichTransitionEnd();
    this.supportsCssTransitions = Modernizr.hasOwnProperty('csstransitions') && Modernizr.csstransitions;

    if(this.$el == undefined || !this.$el.hasClass(classes.drawer)) {
      console.warn('['+this.name+'] - Element with class `'+classes.drawer+'` required to initialize.');
      return;
    }     

    var defaults = {
      closeSelector: selectors.close,
      backdrop: true
    };

    this.settings = $.extend({}, defaults, options);

    this.events = {
      HIDE:   'hide'   + this.namespace,
      HIDDEN: 'hidden' + this.namespace,
      SHOW:   'show'   + this.namespace,
      SHOWN:  'shown'  + this.namespace
    };    

    // check to see if we're on an ios device and using safari based on the presence of substrings in the user agent. 
    var ua = navigator.userAgent.toLowerCase();
    // If we're on an ios device the user agent will contain one of these three device identifiers
    if (ua.indexOf('iphone') != -1 || ua.indexOf('ipod') != -1 || ua.indexOf('ipad') != -1) {
      // If we're on safari the user agent will contain the strings 'safari' and not the substring 'chrome'
      if (ua.indexOf('safari') != -1 && ua.indexOf('chrome') == -1) {
        // we are on an ios device using safari

        // when tabbing out of the mobile search bar with the arrows in the keyboard close the drawer
        $(selectors.mobileSearch).on('blur', this.onCloseClick.bind(this));;
      }
    }

    this.$el.on('click', this.settings.closeSelector, this.onCloseClick.bind(this));

  }

  Drawer.prototype = $.extend({}, Drawer.prototype, {

    addBackdrop: function(callback) {
      var _this = this;
      var cb    = callback || $.noop;

      if(this.stateIsOpen) {
        this.$backdrop = $(document.createElement('div'));

        this.$backdrop.addClass(classes.backdrop)
                      .appendTo($body);

        this.$backdrop.one(this.transitionEndEvent, cb);
        this.$backdrop.one('click', this.hide.bind(this));

        // debug this...
        setTimeout(function() {
          $body.addClass(classes.bodyDrawerOpen);          
          _this.$backdrop.addClass(classes.backdropVisible);
        }, 10);
      }
      else {
        cb();
      }
    },

    removeBackdrop: function(callback) {
      var _this = this;
      var cb    = callback || $.noop;

      if(this.$backdrop) {
        this.$backdrop.one(this.transitionEndEvent, function(){
          _this.$backdrop && _this.$backdrop.remove();
          _this.$backdrop = null;
          cb();
        });

        setTimeout(function() {
          _this.$backdrop.removeClass(classes.backdropVisible);
          $body.removeClass(classes.bodyDrawerOpen);
        }, 10);
      }
      else {
        cb();
      }
    },
    
    /**
     * Called after the closing animation has run
     */    
    onHidden: function() {
      this.stateIsOpen = false;
      var e = $.Event(this.events.HIDDEN);
      this.$el.trigger(e);
    },

    /**
     * Called after the opening animation has run
     */
    onShown: function() {
      var e = $.Event(this.events.SHOWN);
      this.$el.trigger(e);
    },

    hide: function() {
      var e = $.Event(this.events.HIDE);
      this.$el.trigger(e);

      if(!this.stateIsOpen) return;

      this.$el.removeClass(classes.visible);

      if(this.settings.backdrop) {
        this.removeBackdrop();
      }        

      if(this.supportsCssTransitions) {
        this.$el.one(this.transitionEndEvent, this.onHidden.bind(this));
      }
      else {
        this.onHidden();
      }
    },

    show: function() {
      var e = $.Event(this.events.SHOW);
      this.$el.trigger(e);

      if(this.stateIsOpen) return;

      this.stateIsOpen = true;

      this.$el.addClass(classes.visible);

      if(this.settings.backdrop) {
        this.addBackdrop();
      }

      if(this.supportsCssTransitions) {
        this.$el.one(this.transitionEndEvent, this.onShown.bind(this));
      }
      else {
        this.onShown();
      }        
    },

    toggle: function() {
      return this.stateIsOpen ? this.hide() : this.show();
    },

    onCloseClick: function(e) {
      e.preventDefault();
      this.hide();
    }
  });

  // DRAWER DATA-API
  // ===============

  $document.on('click.drawer', '[data-toggle="drawer"]', function (e) {

    var $this   = $(this);
    var $target = $($this.attr('data-target'));
    var options = $.extend($target.data(), $this.data());
    var data    = $this.data('drawer');

    if ($this.is('a')) e.preventDefault();

    if(!data) {
      $this.data('drawer', (data = new Drawer($target, options)));
      data.show();
    }
    else {
      data.toggle();
    }

  });  

  return Drawer;
  
}(jQuery, Modernizr));
/**
 * Slideshow
 * ------------------------------------------------------------------------------
 *
 * Requires:
 *  - slick.min.js
 *  - Modernizr
 *
 * - NOTE: Slideshow wrapper is *not* required to initialize, but it is required if you want to take advantage of the a11y code inside here
 *
 * @namespace - models.Slideshow
*/

slate.models = slate.models || {};

slate.models.Slideshow = (function($, Modernizr) {

  var selectors = {
    slideshowWrapper: '[data-slideshow-wrapper]',
    slideshow: '[data-slideshow]'
  };

  var KEYS = {
    left: 37,
    right: 39
  };

 /**
  * Slideshow constructor
  *
  * @param {HTMLElement | $} el - The actual slideshow element
  * @param {Object} options - Options passed into the slider initialize function
  */
  function Slideshow(el, options) {

    var $el = $(el);

    this.$slideshow = $el;
    this.$wrapper   = $el.closest(selectors.slideShowWrapper);

    if(!this.$slideshow.length){
      console.warn('['+this.name+'] - Slideshow element required to initialize');
      return;
    }

    var fade = this.$slideshow.attr('data-fade') && this.$slideshow.attr('data-fade').length ? this.$slideshow.data('fade') : true; // Allows us to pass data-fade="false".  $.fn.attr coerces to string, $.fn.data does *not*

    var defaults = {
      accessibility: false, // prevents page from jumping on focus
      arrows: !Modernizr.touchevents,
      dots: this.$slideshow.data('dots'),
      fade: fade,
      draggable: true,
      touchThreshold: 20,
      slidesToShow: this.$slideshow.data('slides-to-show') || 1,
      slidesToScroll: this.$slideshow.data('slides-to-scroll') || 1,
      autoplay: this.$slideshow.data('autoplay') || false,
      autoplaySpeed: this.$slideshow.data('speed') || 5000,
      prevArrow: '<div class="slick-arrow slick-arrow--prev" aria-label="Previous Banner"><div class="earmark-arrow earmark-arrow--left"></div></div>',
      nextArrow: '<div class="slick-arrow slick-arrow--next" aria-label="Next Banner"><div class="earmark-arrow earmark-arrow--right"></div></div>',

      // Options below here are not used in slick
      equalHeightSlides: this.$slideshow.data('equal-heights') || false
    };

    this.settings = $.extend({}, defaults, options);

    // Turn off dots if there's only one slide
    if(this.$slideshow.children().length <= 1) {
      this.settings.dots = false;
    }

    // this.$slideshow.on('init', this.slideshowA11y.bind(this));
    this.$slideshow.slick(this.settings);

    if(this.settings.equalHeightSlides) {
      this.$slideshow.addClass('has-equal-height-slides');
    }

    $(window).on('resize', this.onResize.bind(this));

    this.onResize();
  }

  Slideshow.prototype = $.extend({}, Slideshow.prototype, {
   /**
    * Adds events to the slideshow for improved accessibility
    *
    * @param {Event} evt - window event w/ type "init"
    * @param {Object} slick
    */
    slideshowA11y: function(evt, slick) {
      var self     = this;
      var $list    = slick.$list;
      var $dots    = slick.$dots;
      var $wrapper = this.$wrapper;
      var autoplay = this.settings.autoplay;

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused
      // pause slideshow and set aria-live.
      $wrapper.on('focusin', function(evt) {
        if (!$wrapper.has(evt.target).length) {
          return;
        }

        $list.attr('aria-live', 'polite');

        if (autoplay) {
          self.pause();
        }
      });

      // Resume autoplay
      $wrapper.on('focusout', function(evt) {
        if (!$wrapper.has(evt.target).length) {
          return;
        }

        $list.removeAttr('aria-live');

        if (autoplay) {
          self.play();
        }
      });

      // Add arrow key support when focused
      if ($dots) {
        $dots.on('keydown', function(evt) {
          if (evt.which === KEYS.left) {
            self.prev();
          }

          if (evt.which === KEYS.right) {
            self.next();
          }

          // Update focus on newly selected tab
          if ((evt.which === KEYS.left) || (evt.which === KEYS.right)) {
            $dots.find('.slick-active button').focus();
          }
        });
      }
    },

    next: function() {
      this.$slideshow.slick('slickNext');
    },

    prev: function() {
      this.$slideshow.slick('slickPrev');
    },

    pause: function() {
      this.$slideshow.slick('slickPause');
    },

    play: function() {
      this.$slideshow.slick('slickPlay');
    },

    unpause: function() {
      if(this.settings.autoplay) {
        this.play();
      }
    },

    onResize: function() {
      var slick = this.$slideshow.slick('getSlick');
      if(slick) {
        if (slick.options.slidesToShow > slick.slideCount){
          $('.slick-dots').hide();
        }
      }
    },

   /**
    * Finds and displays a slide associated with the blockId passed in.
    * Note:  Block IDs are not required on slides for the slideshow to work
    *        If used, the slide element must have the attribute - data-block-id="{{ block.id }}"
    *
    * @param {string} blockId
    */
    goToSlideByBlockId: function(blockId) {
      var slick = this.$slideshow.slick('getSlick');
      var $slide = slick.$slides.filter('[data-block-id="' + blockId + '"]:not(.slick-cloned)');

      this.$slideshow.slick('slickGoTo', $slide.data('slick-index') );
    }

  });

  return Slideshow;
}(jQuery, Modernizr));

/**
 * Product Carousel
 * ------------------------------------------------------------------------------
 *
 * Requires:
 *  - slick.min.js
 *  - Modernizr
 *
 * - NOTE: Slideshow wrapper is *not* required to initialize, but it is required if you want to take advantage of the a11y code inside here
 *
 * @namespace - models.ProductCarousel
*/

slate.models = slate.models || {};

slate.models.ProductCarousel = (function($, Modernizr) {

  var selectors = {
    slideshowWrapper: '[data-slideshow-wrapper]',
    slideshow: '[data-slideshow]',
    slides: '[data-slide]'
  };

 /**
  * ProductCarousel constructor
  *
  * @param {HTMLElement | $} el - The element containing the slideshow and buttons / arrows / dots, etc
  */
  function ProductCarousel(el) {

    this.name = 'productCarousel';

    if(!$(el).length){
      console.warn('['+this.name+'] - Carousel element required to initialize');
      return;
    }

    this.$el = $(el);
    this.$slideshowWrapper = this.$el.find(selectors.slideshowWrapper);
    this.$slideshow = this.$el.find(selectors.slideshow);
    this.$slides = this.$el.find(selectors.slides);

    var options = {
      slidesToShow: 4,
      slidesToScroll: 4,
      dots: true,
      infinite: false,
      fade: false,
      arrows: true,
      prevArrow: $('.product-carousel__arrow-prev', this.$el),
      nextArrow: $('.product-carousel__arrow-next', this.$el),
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
            dots: this.$slides.length > 16 ? false : true,
            appendDots: $('.product-carousel--mobile__dots', this.$el),
            appendArrows: $('.product-carousel--mobile__container', this.$el),
            arrows: true,
            prevArrow: $('.product-carousel--mobile__arrow-prev', this.$el),
            nextArrow: $('.product-carousel--mobile__arrow-next', this.$el),
          }
        }
      ]
    };

    if (this.$slides.length > 1) {
      this.slideshow = new slate.models.Slideshow(this.$slideshow, options);
    
      $(window).on('resize', this.onResize.bind(this));

      this.onResize();
    } else {
      console.warn('['+this.name+'] Slides required for this module to initialize');
    }
  }

  ProductCarousel.prototype = $.extend({}, ProductCarousel.prototype, {
    onResize: function() {
      var slick = this.slideshow.$slideshow.slick('getSlick');
      if(slick) {
        if (slick.options.slidesToShow >= slick.slideCount){
          $('.slick-dots').hide();
        }
      }
    }
  });

  return ProductCarousel;
}(jQuery, Modernizr));

/**
 * Article Carousel
 * ------------------------------------------------------------------------------
 *
 * Requires:
 *  - slick.min.js
 *  - Modernizr
 *
 * - NOTE: Slideshow wrapper is *not* required to initialize, but it is required if you want to take advantage of the a11y code inside here
 *
 * @namespace - models.ArticleCarousel
*/

slate.models = slate.models || {};

slate.models.ArticleCarousel = (function($, Modernizr) {

  var selectors = {
    slideshowWrapper: '[data-slideshow-wrapper]',
    slideshow: '[data-slideshow]',
    slide: '[data-slide]'
  };

 /**
  * ArticleCarousel constructor
  *
  * @param {HTMLElement | $} el - The element containing the slideshow and buttons / arrows / dots, etc
  */
  function ArticleCarousel(el) {
    this.name = 'articleCarousel';
    
    if(!$(el).length){
      console.warn('['+this.name+'] - Carousel element required to initialize');
      return;
    }
    
    this.$el = $(el);
    this.$slideshowWrapper = this.$el.find(selectors.slideshowWrapper);
    this.$slideshow = this.$el.find(selectors.slideshow);
    this.$slides = $(selectors.slide, this.$container);

    var options = {
      slidesToShow: ( this.$slides.length >= 3 ) ? 3 : 1,
      slidesToScroll: 3,
      dots: false,
      infinite: true,
      fade: false,
      arrows: true,
      prevArrow: $('.article-carousel__arrow-prev', this.$el),
      nextArrow: $('.article-carousel__arrow-next', this.$el),
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            appendDots: $('.article-carousel--mobile__dots', this.$el),
            appendArrows: $('.article-carousel--mobile__container', this.$el),
            arrows: true,
            prevArrow: $('.article-carousel--mobile__arrow-prev', this.$el),
            nextArrow: $('.article-carousel--mobile__arrow-next', this.$el),
          }
        }
      ]
    };

    this.slideshow = new slate.models.Slideshow(this.$slideshow, options);
    
    $(window).on('resize', this.onResize.bind(this));

    this.onResize();
  }

  ArticleCarousel.prototype = $.extend({}, ArticleCarousel.prototype, {
    onResize: function() {
      var slick = this.slideshow.$slideshow.slick('getSlick');
      if(slick) {
        if (slick.options.slidesToShow >= slick.slideCount){
          $('.slick-dots').hide();
        }
      }
    }
  });

  return ArticleCarousel;
}(jQuery, Modernizr));

/**
 * Video Carousel
 * ------------------------------------------------------------------------------
 *
 * Requires:
 *  - slick.min.js
 *  - Modernizr
 *
 * - NOTE: Slideshow wrapper is *not* required to initialize, but it is required if you want to take advantage of the a11y code inside here
 *
 * @namespace - models.VideoCarousel
*/

slate.models = slate.models || {};

slate.models.VideoCarousel = (function($, Modernizr) {

  var selectors = {
    slideshowWrapper: '[data-slideshow-wrapper]',
    slideshow: '[data-slideshow]'
  };

 /**
  * VideoCarousel constructor
  *
  * @param {HTMLElement | $} el - The element containing the slideshow and buttons / arrows / dots, etc
  */
  function VideoCarousel(el) {

    this.name = 'videoCarousel';

    if(!$(el).length){
      console.warn('['+this.name+'] - Carousel element required to initialize');
      return;
    }

    this.$el = $(el);
    this.$slideshowWrapper = this.$el.find(selectors.slideshowWrapper);
    this.$slideshow = this.$el.find(selectors.slideshow);

    var options = {
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      infinite: true,
      fade: false,
      arrows: true,
      prevArrow: $('.video-carousel__arrow-prev', this.$el),
      nextArrow: $('.video-carousel__arrow-next', this.$el),
      centerMode: true,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            appendDots: $('.video-carousel--mobile__dots', this.$el),
            appendArrows: $('.video-carousel--mobile__container', this.$el),
            arrows: true,
            prevArrow: $('.video-carousel--mobile__arrow-prev', this.$el),
            nextArrow: $('.video-carousel--mobile__arrow-next', this.$el),
          }
        }
      ]
    };

    this.slideshow = new slate.models.Slideshow(this.$slideshow, options);
    
    $(window).on('resize', this.onResize.bind(this));

    this.onResize();
  }

  VideoCarousel.prototype = $.extend({}, VideoCarousel.prototype, {
    onResize: function() {
      var slick = this.slideshow.$slideshow.slick('getSlick');
      if(slick) {
        if (slick.options.slidesToShow >= slick.slideCount){
          $('.slick-dots').hide();
        }
      }
    }
  });

  return VideoCarousel;
}(jQuery, Modernizr));

/**
 * Product Carousel
 * ------------------------------------------------------------------------------
 *
 * Requires:
 *  - slick.min.js
 *  - Modernizr
 *
 * - NOTE: Slideshow wrapper is *not* required to initialize, but it is required if you want to take advantage of the a11y code inside here
 *
 * @namespace - models.CollectionCarousel
*/

slate.models = slate.models || {};

slate.models.CollectionCarousel = (function($, Modernizr) {

  var selectors = {
    slideshowWrapper: '[data-slideshow-wrapper]',
    slideshow: '[data-slideshow]',
    slides: '[data-slide]'
  };

 /**
  * CollectionCarousel constructor
  *
  * @param {HTMLElement | $} el - The element containing the slideshow and buttons / arrows / dots, etc
  */
  function CollectionCarousel(el) {

    this.name = 'collectionCarousel';

    if(!$(el).length){
      console.warn('['+this.name+'] - Carousel element required to initialize');
      return;
    }

    this.$el = $(el);
    this.$slideshowWrapper = this.$el.find(selectors.slideshowWrapper);
    this.$slideshow = this.$el.find(selectors.slideshow);
    this.$slides = this.$el.find(selectors.slides);

    var options = {
        slidesToShow: 4,
        slidesToScroll: 4,
        nextArrow: $('.collection-carousel__arrow-next'),
        prevArrow: $('.collection-carousel__arrow-prev'),
        fade: false,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
      };
      
    if (this.$slides.length > 1) {
      this.slideshow = new slate.models.Slideshow(this.$slideshow, options);
        
      $(window).on('resize', this.onResize.bind(this));
      
    } else {
      console.warn('['+this.name+'] Slides required for this module to initialize');
    }
  }

  CollectionCarousel.prototype = $.extend({}, CollectionCarousel.prototype, {
    onResize: function() {}
  });

  return CollectionCarousel;
}(jQuery, Modernizr));

/**
 * Product Carousel
 * ------------------------------------------------------------------------------
 *
 * Requires:
 *  - slick.min.js
 *  - Modernizr
 *
 * - NOTE: Slideshow wrapper is *not* required to initialize, but it is required if you want to take advantage of the a11y code inside here
 *
 * @namespace - models.BannerCarousel
*/

slate.models = slate.models || {};

slate.models.BannerCarousel = (function($, Modernizr) {

  var selectors = {
    slideshowWrapper: '[data-slideshow-wrapper]',
    slideshow: '[data-slideshow]',
    slides: '[data-slide]'
  };

 /**
  * BannerCarousel constructor
  *
  * @param {HTMLElement | $} el - The element containing the slideshow and buttons / arrows / dots, etc
  */
  function BannerCarousel(el) {

    this.name = 'bannerCarousel';

    if(!$(el).length){
      console.warn('['+this.name+'] - Carousel element required to initialize');
      return;
    }

    this.$el = $(el);
    this.$slideshowWrapper = this.$el.find(selectors.slideshowWrapper);
    this.$slideshow = this.$el.find(selectors.slideshow);
    this.$slides = this.$el.find(selectors.slides);

    var options = {
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: false
      };
    
    if (this.$slides.length > 1) {
      this.slideshow = new slate.models.Slideshow(this.$slideshow, options);
        
      $(window).on('resize', this.onResize.bind(this));
      
    } else {
      console.warn('['+this.name+'] Slides required for this module to initialize');
    }
  }

  BannerCarousel.prototype = $.extend({}, BannerCarousel.prototype, {
    onResize: function() {}
  });

  return BannerCarousel;
}(jQuery, Modernizr));

/**
 * Slideup
 * ------------------------------------------------------------------------------
 *
 * Requires:
 *  - Modernizr
 *
 * @namespace - models.Slideup
*/

slate.models = slate.models || {};

slate.models.Slideup = (function($, Modernizr) {

  var $document = $(document);

  var selectors = {
    close: '[data-slideup-close]',
  };

  var classes = {
    slideup: 'slideup',
    visible: 'is-visible'
  };

 /**
  * Slideup constructor
  *
  * @param {HTMLElement | $} el - The slideup element
  * @param {Object} options
  */
  function Slideup(el, options) {

    this.name = 'slideup';
    this.namespace = '.'+this.name;

    this.$el = $(el);
    this.stateIsOpen            = false;
    this.transitionEndEvent     = slate.utils.whichTransitionEnd();    
    this.supportsCssTransitions = Modernizr.hasOwnProperty('csstransitions') && Modernizr.csstransitions;


    if (this.$el == undefined || !this.$el.hasClass(classes.slideup)) {
      console.warn('['+this.name+'] - Element with class `'+classes.slideup+'` required to initialize.');
      return;
    }    

    var defaults = {
      closeSelector: selectors.close
    };

    this.settings = $.extend({}, defaults, options);

    this.events = {
      HIDE:   'hide'   + this.namespace,
      HIDDEN: 'hidden' + this.namespace,
      SHOW:   'show'   + this.namespace,
      SHOWN:  'shown'  + this.namespace
    };    

    this.$el.on('click', this.settings.closeSelector, this.onCloseClick.bind(this));

  }

  Slideup.prototype = $.extend({}, Slideup.prototype, {
    
    /**
     * Called after the closing animation has run
     */    
    onHidden: function() {
      var e = $.Event(this.events.HIDDEN);
      this.$el.trigger(e);
    },

    /**
     * Called after the opening animation has run
     */
    onShown: function() {
      var e = $.Event(this.events.SHOWN);
      this.$el.trigger(e);
    },

    hide: function() {
      var e = $.Event(this.events.HIDE);
      this.$el.trigger(e);

      if(!this.stateIsOpen) return;

      this.stateIsOpen = false;

      this.$el.removeClass(classes.visible);

      if(this.supportsCssTransitions) {
        this.$el.one(this.transitionEndEvent, this.onHidden.bind(this));
      }
      else {
        this.onHidden();
      }
    },

    show: function() {
      var e = $.Event(this.events.SHOW);
      this.$el.trigger(e);

      if(this.stateIsOpen) return;

      this.stateIsOpen = true;

      this.$el.addClass(classes.visible);

      if(this.supportsCssTransitions) {
        this.$el.one(this.transitionEndEvent, this.onShown.bind(this));
      }
      else {
        this.onShown();
      }
    },

    toggle: function() {
      return this.stateIsOpen ? this.hide() : this.show();
    },    

    onCloseClick: function(e) {
      e.preventDefault();
      this.hide();
    }
  });

  // SLIDEUP DATA-API
  // ===============

  $document.on('click.slideup', '[data-toggle="slideup"]', function (e) {

    var $this   = $(this);
    var $target = $($this.attr('data-target'));
    var options = $.extend($target.data(), $this.data());
    var data    = $this.data('slideup');

    if ($this.is('a')) e.preventDefault();

    if(!data) {
      $this.data('slideup', (data = new Slideup($target, options)));
      data.show();
    }
    else {
      data.toggle();
    }

  });   

  return Slideup;
}(jQuery, Modernizr));

/**
 * Slideup Alert
 * ------------------------------------------------------------------------------
 *
 * Requires:
 *  - snippets/slideup-template.liquid
 *
 * @namespace - models.SlideupAlert
*/

slate.models = slate.models || {};

slate.models.SlideupAlert = (function($) {

  var $body = $(document.body);

  var selectors = {
    template: 'script[data-slideup-template]'
  };  

 /**
  * Slideup Alert constructor
  *
  * @param {Object} options
  * @param {String} options.title - Title text of the slideup
  * @param {String} options.text - Body text of the slideup
  * @param {Integer} options.timeoutDuration - How long to display the alert before closing automatically (in ms)
  */
  function SlideupAlert(options) {

    this.name = 'slideupAlert';
    this.namespace = '.'+this.name;

    if(!$(selectors.template).length){
      console.warn('['+this.name+'] - Handlebars template required to initialize');
      return;
    }

    var template = Handlebars.compile($(selectors.template).html());
    var defaults = {
      title: null,
      text: null,
      timeoutDuration: 5000
    };
    
    this.settings = $.extend({}, defaults, options);
    this.interactionTimeout = false;

    this.$el = $(template(this.settings));

    this.$el.appendTo($body);

    this.$el.on('shown.slideup', this.onShown.bind(this));
    this.$el.on('hidden.slideup', this.onHidden.bind(this));
    this.$el.on('mouseenter', this.onMouseenter.bind(this));
    this.$el.on('mouseleave', this.onMouseleave.bind(this));    

    this.slideup = new slate.models.Slideup(this.$el);

    setTimeout(function() {
      this.slideup.show();
    }.bind(this), 10);

  }

  SlideupAlert.prototype = $.extend({}, SlideupAlert.prototype, {
    
    setInteractionTimeout: function() {
      this.interactionTimeout = setTimeout(function() {
        this.slideup.hide();
      }.bind(this), this.settings.timeoutDuration);
    },

    clearInteractionTimeout: function() {
      clearTimeout(this.interactionTimeout);
    },

    onMouseenter: function() {
      this.clearInteractionTimeout();
    },

    onMouseleave: function() {
      this.setInteractionTimeout();
    },

    onHidden: function() {
      this.clearInteractionTimeout();
      this.$el.remove();
    },

    onShown: function() {
      this.setInteractionTimeout();
    }

  });

  return SlideupAlert;
}(jQuery));

/**
 * Overlay
 * ------------------------------------------------------------------------------
 *
 * Requires:
 *  - Modernizr
 *
 * @namespace - models.Overlay
*/

slate.models = slate.models || {};

slate.models.Overlay = (function($, Modernizr) {

  var $document = $(document);
  var $body     = $(document.body);

  var selectors = {
    close: '[data-overlay-close]'
  };

  var classes = {
    overlay: 'overlay',
    visible: 'is-visible',
    bodyOverlayOpen: 'overlay-open'
  };

 /**
  * Overlay constructor
  *
  * @param {HTMLElement | $} el - The overlay element
  * @param {Object} options
  */
  function Overlay(el, options) {

    this.name = 'overlay';
    this.namespace = '.'+this.name;

    this.$el      = $(el);

    this.stateIsOpen            = false;
    this.transitionEndEvent     = slate.utils.whichTransitionEnd();    
    this.supportsCssTransitions = Modernizr.hasOwnProperty('csstransitions') && Modernizr.csstransitions;

    if (this.$el == undefined || !this.$el.hasClass(classes.overlay)) {
      console.warn('['+this.name+'] - Element with class `'+classes.overlay+'` required to initialize.');
      return;
    }    

    var defaults = {
      closeSelector: selectors.close
    };

    this.settings = $.extend({}, defaults, options);

    this.events = {
      HIDE:   'hide'   + this.namespace,
      HIDDEN: 'hidden' + this.namespace,
      SHOW:   'show'   + this.namespace,
      SHOWN:  'shown'  + this.namespace,
      FOCUS:  'focus'  + this.namespace,
      KEYDOWN_DISMISS: 'keydown.dismiss' + this.namespace
    };    

    this.$el.on('click', this.settings.closeSelector, this.onCloseClick.bind(this));

  }

  Overlay.prototype = $.extend({}, Overlay.prototype, {
    
    /**
     * Called after the closing animation has run
     */    
    onHidden: function() {
      $body.removeClass(classes.bodyOverlayOpen);

      var e = $.Event(this.events.HIDDEN);
      this.$el.trigger(e);
    },

    /**
     * Called after the opening animation has run
     */
    onShown: function() {
      this.enforceFocus();

      var e = $.Event(this.events.SHOWN);
      this.$el.trigger(e);
      this.$el.trigger('focus');
    },

    hide: function() {
      var e = $.Event(this.events.HIDE);
      this.$el.trigger(e);

      if(!this.stateIsOpen) return;

      this.stateIsOpen = false;

      this.updateEscapeHandler();

      $document.off(this.events.FOCUS);

      this.$el.removeClass(classes.visible);      

      if(this.supportsCssTransitions) {
        this.$el.one(this.transitionEndEvent, this.onHidden.bind(this));
      }
      else {
        this.onHidden();
      }
    },

    show: function() {
      var e = $.Event(this.events.SHOW);
      this.$el.trigger(e);

      if(this.stateIsOpen) return;

      this.stateIsOpen = true;

      this.updateEscapeHandler();

      $body.addClass(classes.bodyOverlayOpen);
      this.$el.addClass(classes.visible);

      if(this.supportsCssTransitions) {      
        this.$el.one(this.transitionEndEvent, this.onShown.bind(this));
      }
      else {
        this.onShown();
      }
    },

    enforceFocus: function() {
      $document.off(this.events.FOCUS);
      $document.on(this.events.FOCUS, $.proxy(function(e) {
        if (document !== e.target && this.$element[0] !== e.target && !this.$element.has(e.target).length) {
          this.$el.trigger('focus');
        }
      }, this));
    },

    updateEscapeHandler: function() {
      if(this.stateIsOpen) {
        this.$el.on(this.events.KEYDOWN_DISMISS, $.proxy(function(e) {
          e.which == 27 && this.hide();
        }, this));
      }
      else {
        this.$el.off(this.events.KEYDOWN_DISMISS);
      }
    },

    toggle: function() {
      return this.stateIsOpen ? this.hide() : this.show();
    },    

    onCloseClick: function(e) {
      e.preventDefault();
      this.hide();
    }
  });

  // OVERLAY DATA-API
  // ===============

  $document.on('click.overlay', '[data-toggle="overlay"]', function (e) {

    var $this   = $(this);
    var $target = $($this.attr('data-target'));
    var options = $.extend($target.data(), $this.data());
    var data    = $this.data('overlay');

    if ($this.is('a')) e.preventDefault();

    if(!data) {
      $this.data('overlay', (data = new Overlay($target, options)));
      data.show();
    }
    else {
      data.toggle();
    }

  });   

  return Overlay;
}(jQuery, Modernizr));

/**
 * Model - Collection Tag Filter Controller
 * ------------------------------------------------------------------------------
 *
 * @namespace - models.collectionTagFilterController
 */

slate.models = slate.models || {};

slate.models.CollectionTagFilterController = (function ($) {

  /**
   * CollectionTagFilterController constructor.
   * - Manages the tag filters applied to the collection page.
   * - All modifications to / queries for filters should go through this guy
   *
   */
  function CollectionTagFilterController() {

    this.name = 'collectionTagFilterController';
    this.cache = false;
    this.tagFilters = [];

    /**
     * Resets the instance's cache object.
     * Needs to be called whenever a tag filter is activated or deactivated to ensure we get fresh data
     *
     */
    this._bustCache = function () {
      this.cache = false;
      return this;
    };

    /**
     * Constructs an object of tag filter data to be consumed by other functions inside this controller
     *
     * @return {Object} obj
     * @return {Array}  obj.types
     * @return {Array}  obj.values
     * @return {Array}  obj.activeTypes
     * @return {Array}  obj.activeValues
     * @return {Array}  obj.inactiveFilters
     * @return {Object} obj.filtersForType
     */
    this._getTagFilterData = function () {

      var data = this.cache;

      if (!data) {

        data = {
          types: [],
          values: [],
          activeTypes: [],
          activeFilters: [],
          activeValues: [],
          inactiveFilters: [],
          filtersForType: {}
        };

        for (var i = this.tagFilters.length - 1; i >= 0; i--) {
          var tf = this.tagFilters[i];
          var val = tf.value;
          var type = tf.type;

          // Update data.types
          if (data.types.indexOf(type) == -1) {
            data.types.push(type);
          }

          // Update data.values
          if (data.values.indexOf(val) == -1) {
            data.values.push(val);
          }

          // Update data.filtersForType
          if (!data.filtersForType.hasOwnProperty(type)) {
            data.filtersForType[type] = [];
          }

          data.filtersForType[type].push(tf);

          // Update data.activeFilters / data.activeTypes / data.activeValues
          if (tf.active) {
            data.activeFilters.push(tf);
            if (data.activeTypes.indexOf(type) == -1) {
              data.activeTypes.push(type);
            }
            if (data.activeValues.indexOf(val) == -1) {
              data.activeValues.push(val);
            }
          }
          else {
            data.inactiveFilters.push(tf);
          }

        }

        this.cache = data;
      }

      return data;
    },

      /**
       * Register an instance of a TagFilter
       * Forloop ensures that we keep a unique list of tag filters based on type and value
       *
       * @param {TagFilter} tagFilter
       */
      this.registerTagFilter = function (tagFilter) {
        if (!(tagFilter instanceof slate.models.CollectionTagFilter)) return;

        for (var i = this.tagFilters.length - 1; i >= 0; i--) {
          if (this.tagFilters[i].type == tagFilter.type && this.tagFilters[i].value == tagFilter.value) {
            return;
          }
        }

        this.tagFilters.push(tagFilter);
      };

    this.activateTagFilterByValue = function (val) {
      var tf = this.getTagFilterByValue(val);

      if (tf) {
        tf.activate();
        this._bustCache();
      }
    };

    this.deactivateTagFilterByValue = function (val) {
      var tf = this.getTagFilterByValue(val);

      if (tf) {
        tf.deactivate();
        this._bustCache();
      }
    };

    this.toggleFilterByValue = function (val) {
      var tf = this.getTagFilterByValue(val);
      if (tf) {
        tf.active ? tf.deactivate() : tf.activate();
        this._bustCache();
      }
    };

    this.deactivateAllFilters = function () {
      $.each(this.getActiveTagFilters(), function (i, tf) {
        tf.deactivate();
      });
      this._bustCache();
    };

    this.getTagFilterTypes = function () {
      return this._getTagFilterData().types;
    };

    this.getActiveTagFilterTypes = function () {
      return this._getTagFilterData().activeTypes;
    };

    this.getActiveTagFilterValues = function () {
      return this._getTagFilterData().activeValues;
    };

    this.getTagFiltersForType = function (type) {
      var filterData = this._getTagFilterData();

      return filterData.filtersForType.hasOwnProperty(type) ? filterData.filtersForType[type] : [];
    };

    this.getActiveTagFilters = function () {
      return this._getTagFilterData().activeFilters;
    };

    this.getInactiveTagFilters = function () {
      return this._getTagFilterData().inactiveFilters;
    };

    this.getActiveTagFiltersForType = function (type) {
      var tfs = this.getTagFiltersForType(type);

      return tfs.filter(function (f) { return f.active; });
    };

    this.getActiveTagFilterValuesForType = function (type) {
      var tfs = this.getActiveTagFiltersForType(type);

      return tfs.map(function (tf) { return tf.value; });
    };

    this.getTagFilterByValue = function (val) {
      for (var i = this.tagFilters.length - 1; i >= 0; i--) {
        var tf = this.tagFilters[i];
        if (tf.value == val) {
          return tf;
        }
      }
    };

    this.getTagFilters = function () {
      return this.tagFilters;
    };
  }

  return CollectionTagFilterController;

})(jQuery);

/**
 * Model - Collection Tag Filter
 * ------------------------------------------------------------------------------
 *
 * @namespace - models.collectionTagFilter
 */

slate.models = slate.models || {};

slate.models.CollectionTagFilter = (function ($) {

  /**
   * CollectionTagFilter constructor.
   *
   * @param {String} type - Filter type (ex. "color", "size-group")
   * @param {String} value - Filter Value (ex. "color-blue", "size-group-small")
   * @param {String} title - Display title (ex. "Blue", "Extra Large")
   * @param {Bool} active - You can specify that the filter is active when you construct it
   */
  function CollectionTagFilter(type, value, title, active) {
    if (!type || !value) {
      return;
    }

    this.type = type;
    this.value = value;
    this.title = title.split(' ').map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1); }).join(' ');
    this.niceType = this.type.split('-').map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1); }).join(' ');
    this.active = active || false;

    return this;
  }

  CollectionTagFilter.prototype = {
    activate: function () {
      this.active = true;
      return this;
    },

    deactivate: function () {
      this.active = false;
      return this;
    },
    getLabel: function () {
      return this.title;
    }
  };

  return CollectionTagFilter;

})(jQuery);

/**
 * Model - Collection Sort
 * ------------------------------------------------------------------------------
 *
 * Dependencies
 *  - slate.utils
 *
 * @namespace - models.collectionSort
 */

 slate.models.CollectionSort = (function(){

  var $body = $(document.body);
  
  var selectors = {
    sortSelect: '[data-sort-select]'
  };

  /**
   * CollectionSort constructor
   *
   * @param {HTMLElement} container - Container element used for scoping any element selection
   * @param {Object} collectionData - see the bottom of `sections/collection.liquid`
   */
  function CollectionSort(container, collectionData) {
    this.$container = $(container);

    this.name = 'collectionSort';
    this.namespace = '.'+this.name;

    // Stop parsing if we don't have the collection data
    if (!collectionData) {
      return;
    }

    this.collectionData = collectionData;

    this.$container.on('change', selectors.sortSelect, this.applySort.bind(this));
  }

  CollectionSort.prototype = $.extend({}, CollectionSort.prototype, {
    applySort: function() {
      var sortBy = $(selectors.sortSelect, this.container).find('option:selected').val();
      var queryParams = slate.utils.getQueryParams();

      if(sortBy !== this.collectionData.sortDefault) {
        queryParams.sort_by = sortBy;
      }
      else {
        delete queryParams.sort_by;
      }

      location.search = $.param(queryParams);
    }
  });

  return CollectionSort;
})();
/**
 * Model - QuickView
 * -----------------------------------------------------------------------------
 * QuickViews are versions of the product detail form that we pull down via AJAX and append to a product card.
 *
 * Requires:
 *  - jQuery
 *  - jQuery.imagesLoaded
 *  - Modernizr (for Modernizr.csstransitions)
 *
 * @namespace models.quickView
 */

 slate.models = slate.models || {};

 slate.models.QuickView = (function($, Modernizr, undefined) {

  var selectors = {
    quickView: '[data-quick-view]',
    quickViewContentsBody: '[data-quick-view-contents-body]',
    quickViewClose: '[data-quick-view-close]',
    productCardContents: '[data-product-card-contents]',
    productDetailForm: '[data-product-detail-form]'
  };

  var classes = {
    quickViewIsOpen: 'is-open',
    productCardHasOpenQuickView: 'has-open-quick-view'
  };  

  /**
   * QuickView constructor
   *
   * @param { Object } settings
   * @param { HTMLElement | jQuery } settings.$productCard
   * @param { String } settings.url - URL pointing to the quick view of the product
   * @param { Function } settings.onProductDetailFormReady - Called after the product form is initialized.  `this` references the QuickView instance
   * @param { Number } settings.transitionDuration - ms
   * @param { String } settings.transitionTimingFunction - string matching a jQuery easing equation.  see slate.animations.
   */
  function QuickView(options) {

    this.name = 'quickView';
    this.namespace = '.'+this.name;

    var self = this;
    var defaults = {
      onProductDetailFormReady: $.noop,
      transitionDuration: 800,
      transitionTimingFunction: 'ease-in-out'
    };

    this.settings = $.extend({}, defaults, options);

    if(typeof this.settings.$productCard == undefined) {
      console.warn('['+this.name+'] - $productCard element required to initialize');
      return;
    }

    if(typeof this.settings.url != "string" || this.settings.url.length == 0 || this.settings.url.indexOf('quick-view') == -1) {
      console.warn('['+this.name+'] - valid URL required to initialize');
      return;
    }

    // Elements we'll need for everything to work
    this.$productCard           = this.settings.$productCard;
    this.$productCardContents   = this.$productCard.find(selectors.productCardContents);
    this.$productDetailForm     = null;
    this.$quickView             = null;
    this.$quickViewContentsBody = null;
    this.$close                 = null;

    this.stateIsOpen               = false;
    this.supportsCssTransitions    = Modernizr.hasOwnProperty('csstransitions') && Modernizr.csstransitions;
    this.productDetailFormInstance = null;

    this.events = {
      OPEN:   'open'   + this.namespace,
      OPENED: 'opened' + this.namespace,
      CLOSE:  'close'  + this.namespace,
      CLOSED: 'closed' + this.namespace,
      LOADED: 'loaded' + this.namespace
    };

    this.$productCard.on('click', selectors.quickViewClose, this.onCloseClick.bind(this));

    this.$productCard.height( this.$productCardContents.outerHeight(true) );

    // Initial ajax request to get the quick view content
    $.get(this.settings.url, this._onAjaxSuccess.bind(this));

    return this;
  }

  QuickView.prototype = {

    /**
     * Initial AJAX Call callback
     * Gets the returned HTML, adds it to the DOM, sets the instance's dom element variables, initializes the product detail form
     *
     */
    _onAjaxSuccess: function(ajaxResponse) {
      this.$productCard.append( $(ajaxResponse).filter('.quick-view') );
      this.$productDetailForm     = this.$productCard.find(selectors.productDetailForm);
      this.$quickView             = this.$productCard.find(selectors.quickView);
      this.$quickViewContentsBody = this.$productCard.find(selectors.quickViewContentsBody);
      this.$close                 = this.$quickView.find(selectors.quickViewClose);

      this.$productDetailForm.on('ready.productDetailForm', this.onProductDetailFormReady.bind(this));

      var config = {
        $el: this.$productDetailForm,
        zoomEnabled: true,
        enableHistoryState: false
      };

      this.productDetailFormInstance = new slate.ProductDetailForm(config);
      this.productDetailFormInstance.initialize();

      // Fire off the loaded event once all the images in the quick view are loaded
      this.$quickView.imagesLoaded()
        .always( function() {
          var e = $.Event(this.events.LOADED);
          this.$productCard.trigger(e);          
        }.bind(this));

    },

    /**
     * Called after the product detail form is done initializing
     */
    onProductDetailFormReady: function() {
      this.settings.onProductDetailFormReady.call(this);
    },

    open: function() {

      this.onOpen();

      if(this.isOpen()) {
        return;
      }

      this.stateIsOpen = true;
      this.doOpenAnimation();
    },

    close: function() {

      this.onClose();

      if(this.isClosed()) {
        return;
      }

      this.stateIsOpen = false;
      this.doCloseAnimation();
    },

    isOpen: function() {
      return this.stateIsOpen;
    },

    isClosed: function() {
      return !this.isOpen();
    },

    /**
     * Called after this.open is called but before any opening animation has run
     */
    onOpen: function() {
      this.$productCard.addClass(classes.productCardHasOpenQuickView);
      var e = $.Event(this.events.OPEN);
      this.$productCard.trigger(e);
    },

    /**
     * Called after this.close is called but before any closing animation has run
     */
    onClose: function() {
      this.$productCard.removeClass(classes.productCardHasOpenQuickView);
      var e = $.Event(this.events.CLOSE);
      this.$productCard.trigger(e);
    },

    /**
     * Called after the opening animation has run
     */
    onOpened: function() {
      var e = $.Event(this.events.OPENED);
      this.$productCard.trigger(e);

    },

    /**
     * Called after the closing animation has run
     */
    onClosed: function() {
      var e = $.Event(this.events.CLOSED);
      this.$productCard.trigger(e);
      this.$quickView.removeClass(classes.quickViewIsOpen);
    },

    doOpenAnimation: function() {

      this.$quickView.addClass(classes.quickViewIsOpen);

      var productCardContentsHeight = this.$productCardContents.outerHeight(true);
      var qvHeight = this.$quickViewContentsBody.outerHeight(true);
      
      this.$productCard.height(productCardContentsHeight);
      this.$quickView.height(0);

      this.setTransitions();
      
      this.$productCard.height(productCardContentsHeight + qvHeight);
      this.$quickView.height(qvHeight);

      if(this.supportsCssTransitions) {
        this.$quickView.one(slate.utils.whichTransitionEnd(), this.onOpened.bind(this));
      }
      else {
        this.onOpened();
      }
    },

    doCloseAnimation: function() {
      this.stateIsOpen = false;
      
      var productCardContentsHeight = this.$productCardContents.outerHeight(true);

      this.$productCard.height(productCardContentsHeight);
      this.$quickView.height(0);

      if(this.supportsCssTransitions) {
        this.$quickView.one(slate.utils.whichTransitionEnd(), this.onClosed.bind(this));
      }
      else {
        this.onClosed();
      }
    },

    onResize: function() {
      var qvHeight = this.$quickViewContentsBody.outerHeight(true);
      var pccHeight = this.$productCardContents.outerHeight(true);

      if(this.isClosed()) {
        this.$productCard.height(pccHeight);
      }
      else {
        this.$productCard.height(pccHeight + qvHeight);
        this.$quickView.height(qvHeight);
      }
    },

    setTransitions: function() {
      var trans = 'height ' + this.settings.transitionDuration + 'ms ' + this.settings.transitionTimingFunction;
      this.$quickView.css( 'transition', trans);
      this.$productCard.css( 'transition', trans);
    },

    scrollToProductCard: function() {
      $('html, body').animate( { scrollTop : (this.$productCard.offset().top - 100) } );
    },
    scrollToQuickView: function() {
      $('html, body').animate( { scrollTop : this.$quickView.offset().top } );
    },
    onCloseClick: function(e) {
      e.preventDefault();
      this.close();
    }
  };

  return QuickView;

})(jQuery, Modernizr);


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 * Uses slate.productDetailForm to handle core product form functionality.
 *
 * - Attaches the `Product` constructor to window.theme.Product.
 *
 * Requires:
 *  - jQuery
 *  - jQuery.fn.zoom - http://www.jacklmoore.com/zoom/
 *  - Slate
 *
 * See:
 * - product.liquid
 * - product-detail-form.liquid
 *
 * @namespace product
 */

theme.Product = (function($, slate) {

  var selectors = {
    addToCartForm: '[data-add-to-cart-form]',
    addToCartFormWrapper: '[data-add-to-cart-form-wrapper]'
  };

  var $window   = $(window);
  var $document = $(document);

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    this.settings = {};
    this.name = 'product';
    this.namespace = '.'+this.name;

    this.events = {
      RESIZE: 'resize'  + this.namespace,
      CLICK: 'click'   + this.namespace,
      SCROLL: 'scroll' + this.namespace
    };

    this.$addToCartFormWrapper = $(selectors.addToCartFormWrapper, this.$container);
    this.$addToCartForm = $(selectors.addToCartForm, this.$container);

    var productDetailForm = new slate.ProductDetailForm({
      $el: this.$container,
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      enableZoom: this.$container.data('zoom-enabled') || false
    });

    productDetailForm.initialize();

    this.$container.on('hidden.bs.modal', '.product-video-banner', this.onVideoModalClose.bind(this));
  }

  Product.prototype = $.extend({}, Product.prototype, {

    onVideoModalClose: function(e) {
      slate.videoPlayer.pauseVideosInContainer(this.$container);
    },

    onScroll: function(e) {
    },

    onResize: function() {
    },
  });

  return Product;
})(jQuery, slate);

/**
 * Collection Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Collection template.
 *
 * @namespace collection
 */

theme.Collection = (function ($, slate) {
  var $window = $(window);

  var selectors = {
    collectionJson: '[data-collection-json]',
    filterTag: '[data-filter-type][data-filter-tag]',
    clearAllFilters: '[data-clear-all-filters]',
    collectionProductCardGrid: '[data-collection-product-card-grid]',
    productCard: '[data-product-card]',
    contentBlockStore: '[data-content-block-store]',
    productGridItemProduct: '[data-product-grid-product]',
    productGridItemContentBlock: '[data-product-grid-content-block]',
    collectionProductCount: '[data-collection-product-count]',
    collectionProductCountLabel: '[data-collection-product-count-label]',
    activeFiltersSlot: '[data-active-filters-slot]',
    collectionFilterDrawer: '[data-collection-filter-drawer]',
    collectionFilterDrawerTrigger: '[data-collection-drawer-filters-trigger]',
    contentGridItem: '.content-grid__item',
    collectionGridEmptyMessage: '[data-collection-grid-empty-message]'
  };

  var classes = {
    filterTagActive: 'is-active',
    filterTagRemoveLink: 'filter-remove-link',
    collectionGridEmptyMessageVisible: 'is-visible'
  };

  function Collection(container) {

    var self = this;

    this.$container = $(container);

    this.name = 'collection';
    this.namespace = '.' + this.name;

    // Stop parsing if we don't have the collection json script tag
    if (!$(selectors.collectionJson, this.$container).html()) {
      console.warn('[' + this.name + '] - Element matching ' + selectors.collectionJson + ' required.');
      return;
    }

    this.transitionEndEvent = slate.utils.whichTransitionEnd();
    this.supportsCssTransitions = Modernizr.hasOwnProperty('csstransitions') && Modernizr.csstransitions;
    this.queryStringFilterParamKey = 'filters';
    this.collectionData = JSON.parse($(selectors.collectionJson, this.$container).html());
    this.sort = new slate.models.CollectionSort(container, this.collectionData);
    this.tagFilterController = new slate.models.CollectionTagFilterController();

    // Elements we'll need
    this.$clearAllFilters = $(selectors.clearAllFilters, this.$container);
    this.$productCardGrid = $(selectors.collectionProductCardGrid, this.$container);
    this.$productCards = this.$productCardGrid.find(selectors.productCard); // Need to look inside of the grid because we can have other prroduct cards inside of the section (recently viewed etc..)
    this.$productCount = $(selectors.collectionProductCount, this.$container);
    this.$productCountLabel = $(selectors.collectionProductCountLabel, this.$container);
    this.$collectionGridEmptyMessage = $(selectors.collectionGridEmptyMessage, this.$container);
    this.$activeFiltersSlot = $(selectors.activeFiltersSlot, this.$container);
    this.$collectionFilterDrawer = $(selectors.collectionFilterDrawer, this.$container);
    this.$collectionFilterDrawerTrigger = $(selectors.collectionFilterDrawerTrigger, this.$container);

    // Create the drawer functionality
    this.filterDrawer = new slate.models.Drawer(this.$collectionFilterDrawer);

    // Register all the tag filters
    $(selectors.filterTag, this.$container).each(function () {
      var $ft = $(this);
      var type = $ft.data('filter-type');
      var title = $ft.attr('title') || $ft.text();
      var value = $ft.data('filter-tag');

      self.tagFilterController.registerTagFilter(new slate.models.CollectionTagFilter(type, value, title));
    });

    // When we load the page, check for filter tag parameters in the URL
    var queryParams = slate.utils.getQueryParams();
    var queryParamFilters = [];

    if (queryParams.hasOwnProperty(this.queryStringFilterParamKey) && queryParams[this.queryStringFilterParamKey].length) {

      queryParamFilters = decodeURIComponent(queryParams[this.queryStringFilterParamKey]).split('+');

      $.each(queryParamFilters, function (i, param) {
        self.tagFilterController.activateTagFilterByValue(param);
      });
    }

    // If we have any active filters, hide all the content, apply the filters + place content blocks, and then fade in the content
    if (this.tagFilterController.getActiveTagFilters().length) {
      self.applyTagFilters();
      // this.fadeOutProductGrid(function() {
      //   self.placeContentBlocks();
      //   self.applyTagFilters();
      // }, 10);
    }
    // Otherwise, just worry about placing the content blocks
    else {
      // this.placeContentBlocks();
    }

    // Add event handlers
    this.$container.on('click', selectors.filterTag, this.onFilterTagClick.bind(this));
    this.$clearAllFilters.on('click', this.onClearAllFiltersClick.bind(this));

    this.$collectionFilterDrawerTrigger.on('click', function (e) {
      e.preventDefault();
      this.filterDrawer.show();
    }.bind(this));

    this.placeContentBlocks();

    $window.on('resize', $.debounce(50, this.handleResize.bind(this)));
  }

  Collection.prototype = $.extend({}, Collection.prototype, {

    /**
     * Creates a remove link from a filterTag
     *
     * @param {Object} filterTag
     * @return {String}
     */
    _createTagRemoveLink: function (filterTag) {
      if (!(filterTag instanceof slate.models.CollectionTagFilter)) return;

      return '<a href="#" class="' + classes.filterTagRemoveLink + '" title="Remove filter" data-filter-type="' + filterTag.type + '" data-filter-tag="' + filterTag.value + '">' + filterTag.getLabel() + '</a>';
    },

    /**
     * Returns a jQuery set of product card elements that satisfy the currently applied filtering
     * If there are no filters, we return the entire set of cards
     *
     * @return {jQuery}
     */
    getPassingProductCards: function () {
      var self = this;
      var $productCardSetFilterOut = this.$productCards; // Start with all the cards, and filter out the ones that pass, leaving the ones that need to be hidden
      var activeFilterTypes = this.tagFilterController.getActiveTagFilterTypes();
      var activeTagFilters = this.tagFilterController.getActiveTagFilters();
      var filterTypes = this.tagFilterController.getTagFilterTypes();

      // We don't have active filters - show everything, nothing needs to be hidden!
      if (!activeFilterTypes.length) {
        return this.$productCards;
      }

      // We DO have active filters - Loop through each product card
      this.$productCards.each(function () {

        var passes = true; // If this is still "true" at the end of all this logic, then the product passes the applied filters and should be displayed
        var $productCard = $(this);
        var dataTags = $productCard.data('tags');

        // If there aren't any tags, return early
        if (!dataTags) {
          passes = false;
          return;
        }

        // Loop through each active filter
        for (var i = activeFilterTypes.length - 1; i >= 0; i--) {
          var activeFilterTypeMatch = false;
          var activeTagFiltersForType = self.tagFilterController.getActiveTagFiltersForType(activeFilterTypes[i]); // [TagFilter, TagFilter]
          var activeTagFilterValuesForType = self.tagFilterController.getActiveTagFilterValuesForType(activeFilterTypes[i]); // ["color-blue", "color-red"]

          for (var k = activeTagFilterValuesForType.length - 1; k >= 0; k--) {
            var activeTagFilterVal = activeTagFilterValuesForType[k]; // "color-blue"

            // as soon as we find a match for this filter type (doesn't matter which value), return it as a match
            // this is how we satisfy the requirement to match ANY filter for a particular filter type (match "red" OR "blue")
            if (dataTags.indexOf(activeTagFilterVal) != -1) {
              activeFilterTypeMatch = true;
              break;
            }
          }

          // Not a match :(
          if (activeFilterTypeMatch == false) {
            passes = false;
            break;
          }
        }

        if (passes) {
          $productCardSetFilterOut = $productCardSetFilterOut.not($productCard); // remove it from the matched set
        }
      });

      return this.$productCards.not($productCardSetFilterOut);
    },

    /**
     * Applies the currently active filters to the collection page
     *
     * @return {self}
     */
    applyTagFilters: function () {

      var $productGridItems = $(selectors.collectionProductCardGrid, this.$container).find(selectors.contentGridItem);
      var $passingProductCards = this.getPassingProductCards();

      // This function does the hiding / showing of the product cards
      var cb = function () {
        if ($passingProductCards.length == 0) {
          $productGridItems.hide();
          this.$collectionGridEmptyMessage.addClass(classes.collectionGridEmptyMessageVisible);
        }
        else if ($passingProductCards.length == this.$productCards.length) {
          $productGridItems.show();
          this.$collectionGridEmptyMessage.removeClass(classes.collectionGridEmptyMessageVisible);
        }
        else {
          $productGridItems.hide();
          $passingProductCards.parent(selectors.contentGridItem).show();
          this.$collectionGridEmptyMessage.removeClass(classes.collectionGridEmptyMessageVisible);
        }

        this.updateProductCountUI($passingProductCards.length);
        this.updateFilterUI();
        this.updateURL();

        $(window).trigger('lookup');
      };

      //. If the drawer is open, it blocks the main UI so we can run updates immediately
      if (this.filterDrawer.stateIsOpen) {
        setTimeout(cb.bind(this), 10);
      }
      else {

        cb.apply(this); // REVIEW
      }
      // else if (this.supportsCssTransitions) {
      //   this.$productCardGrid.one(this.transitionEndEvent, cb.bind(this));
      // }
      // else {
      //   setTimeout(cb.bind(this), 250);
      // }

      return this;
    },

    /**
     * Handle filter tag element click event.
     * Toggles the state of the filter that was clicked on and then applies the tag filters to the collection
     *
     * @param {event} evt
     */
    onFilterTagClick: function (e) {
      e.preventDefault();
      this.tagFilterController.toggleFilterByValue($(e.currentTarget).data('filter-tag'));
      this.applyTagFilters();
    },

    /**
     * Handle clear all element click event
     *
     * @param {event} evt
     */
    onClearAllFiltersClick: function (e) {
      e.preventDefault();
      this.tagFilterController.deactivateAllFilters();
      this.applyTagFilters();
    },

    /**
     * Updates the product count
     *
     * @param {integer} count
     */
    updateProductCountUI: function (count) {
      // Update the collection product count
      if (count == 0) {
        this.$productCount.text('');
        this.$productCountLabel.text('');
        // this.$productCountLabel.text(window.theme.strings.no_products || 'No Products');
      }
      else {
        this.$productCount.text(count);
        this.$productCountLabel.text(slate.utils.pluralize(count, (window.theme.strings.product || 'Product'), (window.theme.strings.products || 'Products')));
      }

    },

    /**
     * Updates the filter UI to reflect the state of active / deactive filters
     *
     */
    updateFilterUI: function () {
      var activeFilters = this.tagFilterController.getActiveTagFilters();
      var inactiveFilters = this.tagFilterController.getInactiveTagFilters();
      var activeFiltersSlotHTML = '';
      var $filterTagEls = $('[data-filter-tag]');

      $.each(activeFilters, function (i, f) {
        $filterTagEls.filter('[data-filter-tag="' + f.value + '"]').addClass(classes.filterTagActive);
      });

      $.each(inactiveFilters, function (i, f) {
        $filterTagEls.filter('[data-filter-tag="' + f.value + '"]').removeClass(classes.filterTagActive);
      });

      if (activeFilters.length) {
        activeFiltersSlotHTML = activeFilters.map(function (tf) { return this._createTagRemoveLink(tf); }.bind(this));
        this.$activeFiltersSlot.html(activeFiltersSlotHTML).slideDown(200);
        this.$clearAllFilters.fadeTo(200, 1);
      }
      else {
        this.$activeFiltersSlot.html('').slideUp(200);
        this.$clearAllFilters.fadeTo(200, 0);
      }
    },

    /**
     * Updates the current URL to reflect the state of the applied filters
     * Appends a query string like ?filter-tags={{ tag1 }}+{{ tag2 }}
     *
     */
    updateURL: function () {
      var queryStringFilterParamValues = this.tagFilterController.getActiveTagFilterValues().join('+');
      var updatedUrl;

      if (window.history) {
        if (queryStringFilterParamValues.length) {
          updatedUrl = slate.utils.getUrlWithUpdatedQueryStringParameter(this.queryStringFilterParamKey, queryStringFilterParamValues);
        }
        else {
          updatedUrl = slate.utils.getUrlWithRemovedQueryStringParameter(this.queryStringFilterParamKey);
        }

        window.history.replaceState({ path: updatedUrl }, '', updatedUrl);
      }

    },

    placeContentBlocks: function(sortNeeded) {
      var sortNeeded = slate.utils.defaultTo(sortNeeded, false);
      var desktop = $window.width() > slate.breakpoints.getBreakpointMinWidth('md');

      var $productGridProducts = $(selectors.productGridItemProduct, this.$container);
      var $productGridContentBlocks = $(selectors.productGridItemContentBlock, this.$container);
      var $contentBlockStore = $(selectors.contentBlockStore, this.$container);
      var outputtedContentBlockCount = 0;

      // First put all the content blocks into the store
      $productGridContentBlocks.detach().appendTo($contentBlockStore);

      if (sortNeeded) {
        // Then sort them by index in case they get mixed up
        // Theme editor screws with the ordering
        $productGridContentBlocks.sort(function (a, b) {
          var aI = parseInt($(a).data('product-grid-content-block'));
          var bI = parseInt($(b).data('product-grid-content-block'));

          if (aI > bI) {
            return 1;
          }
          if (aI < bI) {
            return -1;
          }
          return 0;
        });
      }

      // Then loop through all the product grid products and insert a content block where needed until we run out of content blocks or places to put them
      $productGridProducts.each(function (i) {
        var $gridProduct = $(this);
        var positionFlag;

        if (outputtedContentBlockCount >= $productGridContentBlocks.length) {
          return false; // break $.each
        }

        /*
         * For desktop
         * - Product grid is 4 across
         * - Insert a promo block after every 5 product blocks
         *
         * For mobile
         * - Product grid is 2 across, still placing promo block every 5 blocks
         */
        positionFlag = (i + 1) % 5;

        if (positionFlag == 0) {
          $productGridContentBlocks.eq(outputtedContentBlockCount).detach().insertAfter($gridProduct);
          outputtedContentBlockCount += 1;
        }
      });

      //Then set a max-height = their initial height to prevent stretching due to the flexbox stuff
      this.calcContentBlocksMaxHeight();
    },

    handleResize: function(e){
      var desktop = $window.width() > slate.breakpoints.getBreakpointMinWidth('md');
      if (desktop){
        this.calcContentBlocksMaxHeight();
      } else {
        $(selectors.productGridItemContentBlock, this.$container).css({ maxHeight : 'none'});
      }
    },

    calcContentBlocksMaxHeight: function(){
      var $productGridProduct       = $(selectors.productGridItemProduct, this.$container).eq(0);
      var $productGridContentBlocks  = $(selectors.productGridItemContentBlock, this.$container);

      $productGridContentBlocks.css({ maxHeight : $productGridProduct.height() });
    },

    /**
     * Theme Editor section events below
     */
    onBlockDeselect: function () {
      this.placeContentBlocks(true);
    }
  });

  return Collection;

})(jQuery, slate);


/**
 * Pencil Banner Section Script
 * ------------------------------------------------------------------------------
 * Exposes methods and events for the opening and closing of the banner
 *
 * @namespace - pencilBanner
 */

theme.PencilBanner = (function($) {

  var $window = $(window);

  var selectors = {
    pencilBanner: '[data-pencil-banner]',
    close: '[data-pencil-banner-close]'
  };

  var classes = {

  };

  /**
   * Pencil Banner section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   *
   * @param {string} container - selector for the section container DOM element
   */
  function PencilBanner(container) {
    this.$container = $(container);

    this.name = 'pencilBanner',
    this.namespace = '.'+this.name;

    this.events = {
      SHOW: 'show'   + this.namespace,
      CLOSE: 'close' + this.namespace
    };

    $(selectors.close).on('click', this.onCloseClick.bind(this));    
  }

  PencilBanner.prototype = $.extend({}, PencilBanner.prototype, {

    /**
     * Allows you to run specific code when viewing this section inside the theme editor for a more pleasant experience
     * To use, call this at the end of the constructor method
     */
    initForThemeEditor: function() {
     
      if(slate.utils.isThemeEditor()){
        // Hide the close button to make life simpler
        // $(selectors.close).hide();
      }
    },

    /**
     * STUB METHOD - You need to add implementation details
     * Call this to show the banner
     */
    show: function() {
      console.log('['+this.name+'] - open');
      $window.trigger( $.Event(this.events.SHOW) );
    },

    /**
     * STUB METHOD - You need to add implementation details
     * Call this to close the banner
     */
    close: function() {
      console.log('['+this.name+'] - close');
      $window.trigger( $.Event(this.events.CLOSE) );
    },

    onCloseClick: function(e){
      e.preventDefault();
      this.close();
      $(selectors.pencilBanner).slideUp("slow", function() { $(selectors.pencilBanner).remove();});
    },

    /**
     * Theme Editor section events below
     */
    onSelect: function() {
      console.log('['+this.name+'] - section:select');
    },

    onShow: function() {
      console.log('['+this.name+'] - section:show');
    },

    onLoad: function() {
      console.log('['+this.name+'] - section::load');
    },

    onUnload: function() {
      console.log('['+this.name+'] - section::unload');
    }
  });

  return PencilBanner;
})(jQuery);

/**
 * Subscription Slideup Section Script
 * ------------------------------------------------------------------------------
 *
 * Requires:
 *  - slate.utils
 *  - slate.user
 *  - slate.models.Slideup
 *
 * Details are dependent on:
 *  - Mailing list provider (See settings_schema.json)
 *  - 3rd party ajax / validation scripts
 *
 * @namespace - subscriptionSlideup
 */

theme.SubscriptionSlideup = (function($, slate) {

  var selectors = {
    slideup: '[data-subscription-slideup]',
    klaviyoForm: 'form[data-klaviyo-list-id]',
    formContent: '[data-subscription-slideup-form-content]',
    formMessage: '[data-subscription-slideup-form-message]'
  };

  var classes = {
    showMessage: 'show-message'
  };

  /**
   * Subscription Slideup section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   *
   * @param {string} container - selector for the section container DOM element
   */
  function SubscriptionSlideup(container) {
    this.$container = $(container);

    this.name = 'subscriptionSlideup';
    this.namespace = '.'+this.name;

    this.settings = {
      enabled        : this.$container.data('enabled'),
      delay          : !isNaN(parseInt( this.$container.data('delay')) ) ? (parseInt( this.$container.data('delay') )*1000) : 3000, // delay before showing the modal on pageload,
      seenExpiration : !isNaN(parseInt( this.$container.data('seen-expiration')) ) ? parseInt( this.$container.data('seen-expiration') ) : 30 // days before showing the modal again
    };

    // if seenExpiration is set to 0, set it to 1 year (very far into the future)
    if(this.settings.seenExpiration == 0) {
      this.settings.seenExpiration = 365;
    }

    // DOM elements we'll need
    this.$el          = $(selectors.slideup, this.$container);
    this.$formContent = $(selectors.formContent, this.$container);
    this.$formMessage = $(selectors.formMessage, this.$container);
    this.$klaviyoForm = $(selectors.klaviyoForm, this.$container);

    this.slideup = new slate.models.Slideup(this.$el);

    this.ajaxKlaviyoForm = new slate.AjaxKlaviyoForm(this.$klaviyoForm, {
      listId: this.$klaviyoForm.data('klaviyo-list-id'),
      source: this.$klaviyoForm.data('klaviyo-source'),
      onSubscribeSuccess: this.onSubscribeSuccess.bind(this),
      onSubscribeFail: this.onSubscribeFail.bind(this),
      onSubmitFail: this.onSubmitFail.bind(this)
    });

    /**
     * These are the cookies that we'll use to keep track of how much the user has seen / interacted with the slideup
     */
    this.cookies = {};

    this.cookies.seen = slate.user.generateCookie('subscriptionSlideupSeen');
    this.cookies.seen.value = slate.utils.hashFromString(this.$el.text()).toString(); // Set the cookie value based on the content
    this.cookies.seen.expiration = this.settings.seenExpiration;

    this.cookies.emailCollected = slate.user.generateCookie('emailCollected');
    this.cookies.emailCollected.expiration = this.settings.seenExpiration;

    /**
     * Attach event handlers
     */
    this.$el.on('hide.slideup',   this.onHide.bind(this));
    this.$el.on('hidden.slideup', this.onHidden.bind(this));

    /**
     * Checks the show logic and displays the popup if everything checks out
     */
    if(this.shouldShow()) {
      setTimeout(function(){
        this.slideup.show();
      }.bind(this), this.settings.delay);
    }

  }

  SubscriptionSlideup.prototype = $.extend({}, SubscriptionSlideup.prototype, {

    /**
     * Resets everything to it's initial state.  Only call when slideup isn't visible.
     */
    reset: function() {
      this.$formContent.find('input[type="email"]').val('');
      this.$formMessage.html('');
      this.$formContent.removeClass(classes.showMessage);
    },

    onSubscribeSuccess: function() {
      this.$formMessage.html( this.$formMessage.data('message-success') );
      this.$formContent.addClass(classes.showMessage);

      if(!slate.utils.isThemeEditor()) {
        slate.user.setCookie(this.cookies.emailCollected);
      }
    },

    onSubscribeFail: function () {
      this.$formMessage.html(this.$formMessage.data('message-fail'));
      this.$formContent.addClass(classes.showMessage);
      setTimeout(function () {
        this.$formContent.removeClass(classes.showMessage);
      }.bind(this), 5000);
    },

    onSubmitFail: function() {
      this.$formMessage.html( this.$formMessage.data('message-fail') );
      this.$formContent.addClass(classes.showMessage);
      setTimeout(function(){
        this.$formContent.removeClass(classes.showMessage);
      }.bind(this), 5000);
    },

    shouldShow: function() {

      // Checks should be done in this order!

      if(slate.utils.isThemeEditor() || !this.settings.enabled) {
        return false;
      }

      if(slate.user.hasCookie(this.cookies.emailCollected.name)) {
        return false;
      }

      if( slate.user.hasCookie(this.cookies.seen.name) && slate.user.getCookieValue(this.cookies.seen.name) == this.cookies.seen.value) {
        return false;
      }

      return true;
    },

    onHide: function() {
      if(!slate.utils.isThemeEditor()) {
        slate.user.setCookie(this.cookies.seen);
      }
    },

    onHidden: function() {
      this.reset();
    },

    /**
     * Theme Editor section events below
     */
    onSelect: function() {
      this.slideup.show();
    },

    onDeselect: function() {
      this.slideup.hide();
    }
  });

  return SubscriptionSlideup;
})(jQuery, slate);

/**
 * Instagram Feed Section Script
 * ------------------------------------------------------------------------------
 * 
 * Uses Instafeed.js to interact with Instagram API
 *   - See instafeedjs.com for documentation
 *   - See scripts/vendor directory for source file
 *
 * @namespace - instagramFeed
 */

theme.InstagramFeed = (function($, Instafeed) {

  var selectors = {
    target: '[data-instagram-feed-target]',
    template: 'script[data-instagram-media-template]'
  };

  var classes = {

  };

  /**
   * Instagram Feed section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   *
   * @param {string} container - selector for the section container DOM element
   */
  function InstagramFeed(container) {
    this.$container = $(container);

    this.name = 'instagramFeed';
    this.namespace = '.'+this.name;

    this.$target = $(selectors.target, this.$container);

    // Compile this once during initialization
    this.template = Handlebars.compile($(selectors.template).html());    

    this.settings = {
      accessToken: this.$container.attr('data-access-token'),
      get: 'user',
      mock: true,
      success: this.onInstafeedMockSuccess.bind(this),
      limit: this.$container.attr('data-limit') || 8
    };

    if(!this.settings.accessToken) {
      console.warn('[InstagramFeed] - An access token is required to interact with the Instagram API');
      return;
    }

    this.init();
  }

  InstagramFeed.prototype = $.extend({}, InstagramFeed.prototype, {

    /**
     * Kick off the network requests.  Retrieve the user profile from the API and then fire up the feed.
     *
     */
    init: function() {
      $.ajax({
        type: 'GET',
        url: 'https://api.instagram.com/v1/users/self?access_token=' + this.settings.accessToken,
        dataType: 'jsonp'
      })
      .then(function(response){
        
        // Handle invalid response
        if(response.meta.hasOwnProperty('error_message')){
          console.warn('['+this.name+'] - ' + response.meta.error_message);
          return;
        }

        this.settings.userId = response.data.id;

        /*
         *  Use this space to make any adjustments to the section now that you have access to the user profile object
         */

        this.feed = new Instafeed(this.settings);
        this.feed.run();
      }.bind(this));
    },

  /**
   * Callback that runs after Instafeed.run() if the 'mock' setting is set to true
   * Use this function to sort through images, select proper resolution, and construct a gallery of images to insert into the DOM
   *
   * @param {Object} feed - object returned from Instagram API
   * @param {Array} feed.data - Array of feed data objects containing images + info
   */
    onInstafeedMockSuccess: function(feed) {
      
      var self = this;

      feed.data.forEach(function(photo){

        var data = {
          url: photo.link,
          src: photo.images && photo.images.standard_resolution && photo.images.standard_resolution.url,
          caption: photo.caption && photo.caption.text || ''
        };

        self.$target.append(self.template(data));
      });

    },

    /**
     * Theme Editor section events below
     */
    onSelect: function() {
      console.log('['+this.name+'] - section:select');
    },

    onShow: function() {
      console.log('['+this.name+'] - section:show');
    },

    onLoad: function() {
      console.log('['+this.name+'] - section::load');
    },

    onUnload: function() {
      console.log('['+this.name+'] - section::unload');
    }
  });

  return InstagramFeed;
})(jQuery, Instafeed);

/**
 * Slideshow Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - Slideshow
 */

theme.Slideshow = (function($) {

  var selectors = {
    slideshow: '[data-slideshow]',
  };

  var classes = {

  };
  
  /**
   * Slideshow section constructor
   *
   * @param {string} container - selector for the section container DOM element
   */
  function Slideshow(container) {
    this.$container = $(container);

    this.name = 'slideshow';
    this.namespace = '.'+this.name;

    var settings = {
      arrows: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            arrows: false
          }
        }
      ]
    };

    this.slideshow = new slate.models.Slideshow( $(selectors.slideshow, this.$container), settings);

  }

  Slideshow.prototype = $.extend({}, Slideshow.prototype, {
    /**
     * Theme Editor section events below
     */
    onBlockSelect: function(evt) {
      this.slideshow.goToSlideByBlockId( evt.detail.blockId );
      this.slideshow.pause();
    }
  });

  return Slideshow;
})(jQuery);

/**
 * Header Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - header
 *
 * TODO: make baby bum dropdown display in theme editor onSelect
 */

theme.Header = (function($) {

  var $window = $(window);
  var $body   = $(document.body);

  var selectors = {
    header: '[data-header]',
    headerLogo: '[data-header-logo]',
    dropdownTrigger: '[data-dropdown-trigger][data-block]',
    searchTrigger: '[data-utility-bar-search-trigger]',
    searchClose: '[data-utility-bar-search-close]',
    search: '[data-utility-bar-search]',
    utilityBar: 'div.utility-bar'
  };

  var classes = {
    headerFixed: 'is-fixed',
    siteHasFixedHeader: 'site-fixed-header',
    searchActive: 'is-active',
    scrolled: 'scrolled'
  };

  function Header(container) {

    var _this = this;

    this.$container = $(container);
    this.$el = $(selectors.header, this.$container);
    this.name = 'header';
    this.namespace = '.'+this.name;
    this.dropdownManager = new slate.models.DropdownManager();

    this.events = {
      SCROLL: 'scroll' + this.namespace
    };

    this.$searchTrigger = $(selectors.searchTrigger, this.$container);
    this.$search = $(selectors.search, this.$container);
    this.$searchForm = this.$search.find('form');
    this.$searchClose = $(selectors.searchClose, this.$container);
    this.$headerlogo = $(selectors.headerLogo, this.$container);
    this.scrollPosition = 0;

    // Register each dropdown trigger
    $(selectors.dropdownTrigger, this.$container).each(function(i, trigger) {
      _this.dropdownManager.register( $(trigger) );
    });

    this.$searchClose.on('click', this.onSearchCloseClick.bind(this));
    this.$searchTrigger.on('click', this.onSearchTriggerClick.bind(this));
    this.$search.on('keydown', this.onSearchKeyDown.bind(this));
    this.$container.on('pointerenter mouseenter', this.onMouseEnter.bind(this));
    this.$container.on('pointerleave mouseleave', this.onMouseLeave.bind(this));

    // Set the minimum width of the header logo to whatever it is initially so that menu items don't jump on resize
    this.$headerlogo.css('min-width', this.$headerlogo.outerWidth());

    // We pass in the fixed behavior as a class on the body of the site
    if($body.hasClass(classes.siteHasFixedHeader)) {
      $window.on(this.events.SCROLL, $.throttle(20, this.onScroll.bind(this)));
      this.onScroll(); // hit this one time on init to make sure everything is good
    }

  }

  Header.prototype = $.extend({}, Header.prototype, {

    scrollCheck: function() {
      // Do measurements outside of rAF.
      var scrollTop = $window.scrollTop();
      var containerTop = this.$container.offset()['top'];
      var elementHeight = this.$el.outerHeight();
      var actualOffset = containerTop - elementHeight;

      // Do DOM updates inside.
      requestAnimationFrame(function() {
        if( scrollTop < actualOffset ){
          this.$el.removeClass( classes.headerFixed );
        }
        else {
          this.$el.addClass( classes.headerFixed );
        }
      }.bind(this));

      if($window.width() > slate.breakpoints.getBreakpointMinWidth('md')) {
        // DESKTOP
        if (scrollTop > this.scrollPosition && scrollTop > this.$el.height()) {
          $(selectors.utilityBar).slideUp();
          this.$el.addClass(classes.scrolled);
        } else {
          $(selectors.utilityBar).slideDown();
          this.$el.removeClass(classes.scrolled);
        }
      } else {
        // MOBILE
        if (scrollTop > this.$el.height()) {
          this.$el.addClass(classes.scrolled);
        } else {
          this.$el.removeClass(classes.scrolled);
        }
      }
      this.scrollPosition = scrollTop;
    },

    onScroll: function() {
      this.scrollCheck();
    },

    onMouseEnter: function() {

    },

    onMouseLeave: function() {
      this.dropdownManager.closeAllDropdowns();
    },

    onSearchTriggerClick: function (e) {
      if (!this.$search.hasClass(classes.searchActive)) {
        e.preventDefault();

        if (this.supportsCssTransitions) {
          this.$search.one(this.transitionEndEvent, function () {
            this.$search.find('input[type="search"]').first().focus();
          }.bind(this));
        }

        this.$search.addClass(classes.searchActive);
        return false;
      }
      else {
        this.$searchForm.submit();
      }
    },

    onSearchKeyDown: function (e) {
      if (e && e.which == 27) {
        this.$search.removeClass(classes.searchActive);
      }
    },

    onSearchCloseClick: function (e) {
      e.preventDefault();
      this.$search.removeClass(classes.searchActive);
    },

    /**
     * Theme Editor section events below
     */

    onBlockSelect: function(e) {
      var dropdown = this.dropdownManager.getDropdownByBlockId( e.detail.blockId );

      // Bypass dropdown manager since we're inside the theme editor
      if(dropdown) {
        dropdown.forceOpen();
      }
    },

    onBlockDeselect: function(e) {
      var dropdown = this.dropdownManager.getDropdownByBlockId( e.detail.blockId );

      // Bypass dropdown manager since we're inside the theme editor
      if(dropdown) {
        dropdown.forceClose();
      }
    }
  });

  return Header;
})(jQuery);

/**
 * Footer Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - footer
 */

theme.Footer = (function($) {

  var $window = $(window);

  var selectors = {
    mobileMenuToggle: '[data-dropdown-toggle]',
    mobileMenu: '[data-mobile-menu-list]',
    klaviyoForm: 'form[data-klaviyo-list-id]',
    formContent: '[data-subscription-slideup-form-content]',
    formMessage: '[data-subscription-slideup-form-message]'
  };

  var classes = {
    showFormMessage: "is-visible",
    showMessage: "show-message"
  };

  function Footer(container) {

    this.$container = $(container);

    this.name = 'footer';
    this.namespace = '.'+this.name;

    this.$mobileMenu = $(selectors.mobileMenu, this.$container);
    // DOM elements we'll need
    this.$el          = $(selectors.slideup, this.$container);
    this.$formContent = $(selectors.formContent, this.$container);
    this.$formMessage = $(selectors.formMessage, this.$container);
    this.$klaviyoForm = $(selectors.klaviyoForm, this.$container);

    this.ajaxKlaviyoForm = new slate.AjaxKlaviyoForm(this.$klaviyoForm, {
      listId: this.$klaviyoForm.data("klaviyo-list-id"),
      source: this.$klaviyoForm.data("klaviyo-source"),
      onSubscribeSuccess: this.onSubscribeSuccess.bind(this),
      onSubscribeFail: this.onSubscribeFail.bind(this),
      onSubmitFail: this.onSubmitFail.bind(this)
    });

    this.$container.on('click', selectors.mobileMenuToggle, this.onToggleDropdownClicked.bind(this));
    $window.on('resize', $.throttle(50, this.onResize.bind(this)));

    this.transitionEndEvent     = slate.utils.whichTransitionEnd();
    this.supportsCssTransitions = Modernizr.hasOwnProperty('csstransitions') && Modernizr.csstransitions;
  }

  Footer.prototype = $.extend({}, Footer.prototype, {

    onToggleDropdownClicked: function(e) {
      e.preventDefault();

      var $trigger = $(e.currentTarget);
      var submenuID = '#' + $trigger.data('dropdown-toggle');
      var plusIconID = '#indicator-plus-' + $trigger.data('dropdown-toggle');
      var minusIconID = '#indicator-minus-' + $trigger.data('dropdown-toggle');

      if ($trigger.hasClass('is-closed')) {
        $trigger.removeClass('is-closed');
      } else {
        $trigger.addClass('is-closed');
      }
      $(submenuID).toggle('hidden');
    },

    onSubscribeSuccess: function () {
      this.$formMessage.html(this.$formMessage.data('message-success'));
      this.$formContent.addClass(classes.showMessage);

      if (!slate.utils.isThemeEditor()) {
        slate.user.setCookie(this.cookies.emailCollected);
      }
    },

    onSubscribeFail: function () {
      this.$formMessage.html(this.$formMessage.data('message-fail'));
      this.$formContent.addClass(classes.showMessage);
      setTimeout(function () {
        this.$formContent.removeClass(classes.showMessage);
      }.bind(this), 5000);
    },

    onSubmitFail: function () {
      this.$formMessage.html(this.$formMessage.data('message-fail'));
      this.$formContent.addClass(classes.showMessage);
      setTimeout(function () {
        this.$formContent.removeClass(classes.showMessage);
      }.bind(this), 5000);
    },

    onResize: function () {
      // hide the popover so the content doesn't become misaligned onResize
      $('[data-toggle="popover"]').popover('hide');
    },

    /**
     * Theme Editor section events below
     */
    onSelect: function() {
      console.log('['+this.name+'] - section:select');
    },

    onShow: function() {
      console.log('['+this.name+'] - section:show');
    },

    onLoad: function() {
      console.log('['+this.name+'] - section::load');
    },

    onUnload: function() {
      console.log('['+this.name+'] - section::unload');
    }
  });

  return Footer;
})(jQuery);

/**
 * Ajax Cart Section Script
 * ------------------------------------------------------------------------------
 * Exposes methods and events for the interacting with the ajax cart section.
 * All logic is handled in slate.AjaxCart, this file is strictly for handling section settings and them editor interactions
 *
 * @namespace - ajaxCart
 */

theme.AjaxCart = (function($) {

  var $body = $(document.body);

  /**
   * AjaxCart section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   *
   * @param {string} container - selector for the section container DOM element
   */
  function AjaxCart(container) {
    this.$container = $(container);

    this.name = 'ajaxCart',
    this.namespace = '.'+this.name;

    this.ajaxCart = new slate.AjaxCart();

    if (!$body.hasClass('template-cart')) {
      this.ajaxCart.init();      
    }
  }

  AjaxCart.prototype = $.extend({}, AjaxCart.prototype, {

    /**
     * Theme Editor section events below
     */
    onSelect: function() {
      this.ajaxCart.open();
    },

    onDeselect: function() {
      this.ajaxCart.close();
    },

    onShow: function() {

    },

    onLoad: function() {

    },

    onUnload: function() {

    }
  });

  return AjaxCart;
})(jQuery);

/**
 * Cart Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - cart
 */

theme.Cart = (function($) {

  var selectors = {
    form: '[data-cart-form]',
    itemQtySelect: '[data-item-quantity-select]',    
    quantityAdjuster: '[data-quantity-adjuster][data-updates-key]',
    quantityAdjusterInput: '[data-quantity-adjuster] input[type="number"]',
  };

  var classes = {

  };

  function Cart(container) {

    this.$container = $(container);

    this.name = 'footer';
    this.namespace = '.'+this.name;

    this.$form = $(selectors.form, this.$container);

    // Since we have more than 1 quantity select per row (1 for mobile, 1 for desktop)
    // We need to use single input per row, which is responsible for sending the form data for that line item
    // Watch for changes on the quantity selects, and then update the input.  These two are tied together using a data attribute
    this.$container.on('change', selectors.itemQtySelect, function(){
      var $itemQtyInput = $('[id="' + $(this).data('item-quantity-select') + '"]'); // Have to do '[id=".."]' instead of '#id' because id is generated using {{ item.key }} which has semi-colons in it - breaks normal id select
      $itemQtyInput.val($(this).val());
      $form.submit();
    });    
    this.$container.on('change', selectors.quantityAdjusterInput, this.onQuantityAdjusterInputChange.bind(this));

  }

  Cart.prototype = $.extend({}, Cart.prototype, {
    onQuantityAdjusterInputChange: function(e) {
      e.preventDefault();
      var $adjuster = $(e.currentTarget).parents(selectors.quantityAdjuster);
      var $itemQtyInput = $('[id="' + $adjuster.data('updates-key') + '"]'); // Have to do '[id=".."]' instead of '#id' because id is generated using {{ item.key }} which has semi-colons in it - breaks normal id select
      $itemQtyInput.val($(e.currentTarget).val());
      this.$form.submit();
    },
  });

  return Cart;
})(jQuery);

/**
 * Mobile menu Section Script
 * ------------------------------------------------------------------------------
 * Exposes methods and events for the mobile menu
 *
 * @namespace - mobileMenu
 */

theme.MobileMenu = (function($) {

  var selectors = {
    toggle: '[data-mobile-menu-toggle]',
    menu: '[data-mobile-menu]',
    sunBumToggle: '[data-sun-bum-toggle]',
    babyBumToggle: '[data-baby-bum-toggle]',
    drawerClose: '[data-drawer-close]'
  };

  function MobileMenu(container) {
    this.$container = $(container);

    this.name = 'mobileMenu';
    this.namespace = '.'+this.name;

    this.$el     = $(selectors.menu, this.$container);
    this.$toggle = $(selectors.toggle); // Don't scope to this.$container

    this.$body = $(document.body);

    this.drawer  = new slate.models.Drawer(this.$el);

    this.isSunBumAtStart = !this.$body.hasClass('bb');

    this.$toggle.on('click', this.onToggleClick.bind(this));
    
    this.$container.on('click', selectors.sunBumToggle, this.onToggleSunBum.bind(this));
    this.$container.on('click', selectors.babyBumToggle, this.onToggleBabyBum.bind(this));
    this.$container.on('click', selectors.drawerClose, this.onMobileNavClose.bind(this));
  }

  MobileMenu.prototype = $.extend({}, MobileMenu.prototype, {

    onToggleClick: function(e) {
      e.preventDefault();
      this.drawer.toggle();
    },

    onToggleSunBum: function(e) {
      e.preventDefault();
      this.$body.hasClass('bb') ? this.$body.removeClass('bb') : null;
    },

    onToggleBabyBum: function(e) {
      e.preventDefault();
      !this.$body.hasClass('bb') ? this.$body.addClass('bb') : null;
    },

    onMobileNavClose: function(e) {
      e.preventDefault();

      if (this.isSunBumAtStart && this.$body.hasClass('bb') || !this.isSunBumAtStart && !this.$body.hasClass('bb')) {
        this.$body.hasClass('bb') ?
          window.location.href = '/pages/baby-bum' :
          window.location.href = '/';      
      } 
    },

    /**
     * Theme Editor section events below
     */
    onSelect: function() {
      this.drawer.show();
    },

    onDeselect: function() {
      this.drawer.hide();
    },

    onUnload: function() {
      this.drawer && $('.drawer-backdrop').remove();
    },
  });

  return MobileMenu;
})(jQuery);

/**
 * Blog Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - blog
 */

theme.Blog = (function($) {

  var selectors = {
    contentGrid: '[data-blog-list]',
    contentGridItem: '[data-blog-list-item]',
    pagination: '[data-pagination]',
    nextPageLink: '[data-next-page]',
    seasonLink: '[data-season]'
  };

  function Blog(container) {

    this.$container = $(container);

    this.name = 'blog';
    this.namespace = '.'+this.name;

    this.$container.on('click', selectors.nextPageLink, this.onNextPageLinkClick.bind(this));
    this.$container.on('click', selectors.seasonLink, this.onSeasonLinkClick.bind(this));
  }

  Blog.prototype = $.extend({}, Blog.prototype, {

    onNextPageLinkClick: function(e) {
      e.preventDefault();
      var self     = this;
      var $link    = $(e.currentTarget);
      var url      = $link.attr('href');

      $.ajax({
        url: url,
        beforeSend: function() {
          $link.html(theme.strings.loading || 'Loading');
        }
      })
      .done(function( data ) {
        var $dom = $(data);
        var $contentItems = $(selectors.contentGridItem, $dom);
        var $newNextPageLink = $(selectors.nextPageLink, $dom);

        $(selectors.contentGrid, self.$container).append($contentItems);

        if($newNextPageLink.length) {
          $link.replaceWith($newNextPageLink);
        }
        else {
          $(selectors.pagination, self.$container).remove();
        }
      });

    },
    onSeasonLinkClick: function(e) {
      e.preventDefault();  
      var targetSection = $(e.target).data('season');
      var $this = $("#season-" + targetSection).first();
      
      $('.porch-link', this.$container).removeClass('selected');
      $(e.target).addClass('selected');

      $('html, body').animate(
        {
          scrollTop: ($this.offset().top - 150),
        },{
          duration: 1000
        }
      )
    }
  });

  return Blog;
})(jQuery);

// prettier-ignore
/**
 * Blog Powered Section Script
 * ------------------------------------------------------------------------------
 *
 * These are pages with content pulled in through a single blog, organized by tag
 *
 * @namespace - blog
 */

theme.BlogPowered = (function ($) {

  var selectors = {
    tagBarLink: '[data-tag-link]',
    tagBarDropdown: '[data-tag-dropdown]',
    taggedContent: '[data-tagged-content]'
  };

  var classes = {
    linkActive: 'is-active'
  };

  function BlogPowered(container) {

    this.$container = $(container);

    this.name = 'blog';
    this.namespace = '.' + this.name;

    this.transitionDuration = slate.animations.getTransitionTimingDuration('base');
    this.currentTag = null;

    this.$taggedContent = $(selectors.taggedContent, this.$container);
    this.$tagLinks = $(selectors.tagBarLink, this.$container);
    this.$tagBarDropdown = $(selectors.tagBarDropdown, this.$container);

    this.$container.on('click', selectors.tagBarLink, this.onTagBarLinkClick.bind(this));
    this.$container.on('change', selectors.tagBarDropdown, this.onTagBarDropdownChange.bind(this));
  }

  BlogPowered.prototype = $.extend({}, BlogPowered.prototype, {

    switchToTag: function (tag) {

      var self = this;

      if (tag == this.currentTag) return;

      // Active stuff is what we're switching *to*
      // Inactive is what we're switching away from

      var $activeLink = this.$tagLinks.filter('[data-tag-link="' + tag + '"]');
      var $activeContent = this.$taggedContent; // This way if they click on "All" it will show everything

      if (tag.length != 0) {
        $activeContent = $activeContent.filter('[data-tagged-content="' + tag + '"]');
      }

      var $inactiveLinks = this.$tagLinks.not($activeLink);

      $inactiveLinks.parent().removeClass(classes.linkActive);
      $activeLink.parent().addClass(classes.linkActive);

      this.$tagBarDropdown.val(tag);
      this.$tagBarDropdown.trigger("chosen:updated");

      // Visibility filter so we don't call fadeout on elements that are already hidden
      // Reduces the number of times the callback is triggered
      var $inactiveContent = this.$taggedContent.not($activeContent).filter(':visible');

      if ($inactiveContent.length) {
        $inactiveContent.fadeOut(self.transitionDuration, function () {
          $activeContent.fadeIn(self.transitionDuration);
        });
      }
      else {
        $activeContent.fadeIn(self.transitionDuration);
      }

      this.currentTag = tag;
    },

    onTagBarDropdownChange: function (e) {
      e.preventDefault();
      this.switchToTag($(e.currentTarget).val());
    },

    onTagBarLinkClick: function (e) {
      e.preventDefault();
      this.switchToTag($(e.currentTarget).data('tag-link'));
    }
  });

  return BlogPowered;
})(jQuery);
// prettier-ignore-end

/**
 * ProductCarousel Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - ProductCarousel
 */

theme.ProductCarousel = (function($) {
  /**
   * ProductCarousel section constructor
   *
   * @param {string} container - selector for the section container DOM element
   */
  //

  function ProductCarousel(container) {
    this.$container = $(container);

    this.productCarousel = new slate.models.ProductCarousel(this.$container);
  }

  ProductCarousel.prototype = $.extend({}, ProductCarousel.prototype, {
    /**
     * Theme Editor section events below
     */
    onBlockSelect: function(evt) {
      this.productCarousel.slideshow.goToSlideByBlockId(evt.detail.blockId);
      this.productCarousel.slideshow.pause();
    }
  });

  return ProductCarousel;
})(jQuery);

/**
 * Article Carousel Section Script
 * -----------------------------------------------------------------------------
 *
 * Carousel are slideshows with 2+ slidesToShow
 *
 * @namespace - ArticleCarousel
 */

theme.ArticleCarousel = (function($) {

  /**
   * Carousel section constructor
   *
   * @param {string} - container - selector for the section container DOM element
   */
  function ArticleCarousel(container) {
    this.$container = $(container);

    this.articleCarousel = new slate.models.ArticleCarousel(this.$container);
  }

  ArticleCarousel.prototype = $.extend({}, ArticleCarousel.prototype, {
    /**
     * Theme Editor section events below
     */
    onBlockSelect: function (evt) {
      this.slideshow.goToSlideByBlockId(evt.detail.blockId);
      this.slideshow.pause();
    }
  });

  return ArticleCarousel;
})(jQuery);

/**
 * Video  Carousel Section Script
 * -----------------------------------------------------------------------------
 *
 * Carousel are slideshows with 2+ slidesToShow
 *
 * @namespace - Video Carousel
 */

theme.VideoCarousel = (function($) {
  var selectors = {
    slideshow: '[data-slideshow]',
    slide: '.content-grid__item'
  };

  var classes = {};

  /**
   * Carousel section constructor
   *
   * @param {string} - container - selector for the section container DOM element
   */
  function VideoCarousel(container) {
    this.$container = $(container);

    this.videoCarousel = new slate.models.VideoCarousel(this.$container);
  }

  VideoCarousel.prototype = $.extend({}, VideoCarousel.prototype, {
    /**
     * Theme Editor section events below
     */
    onBlockSelect: function (evt) {
      this.slideshow.goToSlideByBlockId(evt.detail.blockId);
      this.slideshow.pause();
    }
  });

  return VideoCarousel;
})(jQuery);

/**
 * Search Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - search
 */

theme.Search = (function($) {

  var selectors = {
    pagination: '[data-search-pagination]',
    nextPageLink: '[data-next-page]',
    searchResultGrid: '[data-search-results]',
    searchResultGridItem: '[data-search-restul-item]',
    backInStockTrigger: '[data-back-in-stock-trigger]',
    backInStockTriggerInner: '[data-back-in-stock-trigger-inner]',
    slideshow: '[data-slideshow]'
  };

  var classes = {

  };

  function Search(container) {

    this.$container = $(container);

    this.name = 'search';
    this.namespace = '.'+this.name;

    this.$container.on('click', selectors.nextPageLink, this.onNextPageLinkClick.bind(this));

    this.$nextPageLink = $( selectors.nextPageLink, this.$container );

    var settings = {
      fade: false,
      dots: true,
      arrows: true,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      cssEase: slate.animations.getTransitionTimingFunction("inOutUI"),
      speed: slate.animations.getTransitionTimingDuration("slow"),
      responsive: [
        {
          breakpoint: 992,
          settings: {
            arrows: true,
            slidesToShow: 3,
            slidesToScroll: 3,
            dots: true
          }
        }
      ]
    };

    this.slideshow = new slate.models.Slideshow( $(selectors.slideshow, this.$container), settings);
  }

  Search.prototype = $.extend({}, Search.prototype, {

    onNextPageLinkClick: function(e) {

      e.preventDefault();
      var self     = this;
      var $link    = $(e.currentTarget);
      var url      = $link.attr('href');

      $.ajax({
        url: url,
        beforeSend: function() {
          $link.html(theme.strings.loading || 'Loading');
        }
      })
      .done(function( data ) {
        var $dom = $(data);
        var $contentItems = $(selectors.searchResultGridItem, $dom);
        var $newNextPageLink = $(selectors.nextPageLink, $dom);

        $(selectors.searchResultGrid, self.$container).append($contentItems);

        if($newNextPageLink.length) {
          $link.replaceWith($newNextPageLink);
        }
        else {
          $(selectors.pagination, self.$container).remove();
        }
      });

    }

  });

  return Search;
})(jQuery);

/**
 * CMS Page Section Script
 * ------------------------------------------------------------------------------
 *
 * Requires:
 * - slick.min.js
 * @namespace - cmsPage
 * 
 */

theme.CMSPage = (function($) {

  var selectors = {
    productCarousel: '[data-product-carousel]',
    bannerCarousel: '[data-banner-carousel]',
    articleCarousel: '[data-article-carousel]',
    videoCarousel: '[data-video-carousel]',
    collectionCarousel: '[data-collection-carousel]'
  };

  var classes = {

  };
  
  function CMSPage(container) {

    this.$container = $(container);

    this.name = 'cmsPage';
    this.namespace = '.'+this.name;

    // Props
    this.productCarousels = [];
    this.bannerCarousel = [];
    this.articleCarousel = [];
    this.videoCarousel = [];
    this.collectionCarousel = [];

    // Carousels
    this.$container.find(selectors.productCarousel).each(function(i, el) {
      var pc = new slate.models.ProductCarousel(el);
      this.productCarousels.push(pc);
    }.bind(this));

    this.$container.find(selectors.articleCarousel).each(function(i, el) {
      var ac = new slate.models.ArticleCarousel(el);
      this.articleCarousel.push(ac);
    }.bind(this));

    this.$container.find(selectors.videoCarousel).each(function(i, el) {
      var vc = new slate.models.VideoCarousel(el);
      this.videoCarousel.push(vc);
    }.bind(this));

    this.$container.find(selectors.collectionCarousel).each(function(i, el) {
      var cc = new slate.models.CollectionCarousel(el);
      this.collectionCarousel.push(cc);
    }.bind(this));

    this.$container.find(selectors.bannerCarousel).each(function(i, el) {
      var ss = new slate.models.BannerCarousel(el);
      this.bannerCarousel.push(ss);
    }.bind(this));
  }

  CMSPage.prototype = $.extend({}, CMSPage.prototype, {
    onUnload: function() {
    }
  });

  return CMSPage;

})(jQuery);


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  var selectors = {
    addressNewToggle: '[data-address-new-toggle]',
    addressEditToggle: '[data-address-edit-toggle][data-form-id]',
    addressDelete: '[data-address-delete][data-form-id]'
  };

  // Toggle new/edit address forms
  $(selectors.addressNewToggle).on('click', function(e) {
    e.preventDefault();
    $newAddressForm.toggleClass('hide');
  });

  $(selectors.addressEditToggle).on('click', function(e) {
    e.preventDefault();
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $(selectors.addressDelete).on('click', function(e) {
    e.preventDefault();
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAccount
 */

theme.customerAccount = (function() {

  var $window = $(window);
  var $body   = $(document.body);

  var selectors = {
    purchaseHistory: '[data-purchase-history]',
    accountDetails: '[data-billing-information]',
    accountButton: '[data-account-button]',
    purchaseButton: '[data-orders-button]',
    selecContainer: '[data-sidebar-select]',
    mobileOrder: '[data-mobile-order]'
  };

  function loadOrders() {
    $(selectors.purchaseButton).siblings().removeClass('is-active');
    $(selectors.purchaseButton).addClass('is-active');
    $(selectors.accountDetails).addClass('hidden');
    $(selectors.purchaseHistory).removeClass('hidden');
  }

  $(selectors.selecContainer).on('change', function () {
    var newUrl = $(this).val();
    if (newUrl.indexOf('#orders')) {
      loadOrders();
    }
    window.location.href = newUrl;
  })

  if(window.location.href.indexOf("orders") > -1) {
    loadOrders();
    $(selectors.mobileOrder).prop('selected', true);
  }

  if ($body.hasClass("template-account")) {
    $(selectors.accountButton).on('click', function(e) {
      $(this).siblings().removeClass('is-active');
      $(this).addClass('is-active');
      $(selectors.purchaseHistory).addClass('hidden');
      $(selectors.accountDetails).removeClass('hidden');
    });

    $(selectors.purchaseButton).on('click', function(e) {
      $(this).siblings().removeClass('is-active');
      $(this).addClass('is-active');
      $(selectors.accountDetails).addClass('hidden');
      $(selectors.purchaseHistory).removeClass('hidden');
    });
  }

})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
    $('#RecoverPassword').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

/**
 * Styleguide Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the styleguide page template.
 *
 * Use this to hook up any JS necessary to show element functionality.
 */

 theme.styleguide = (function() {
  
  var $body = $(document.body);
  
  var selectors = {
    dot: '.dot'
  };

  if( !$body.is('.template-page-styles') ){
    return;
  }

  $body.on('click', selectors.dot, function(){
    $(this).toggleClass('is-active');
  });

  $body.on('click', 'a[href="#"]', function(){
    return false;
  });

})();

/**
 * Styleguide Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the components page template.
 *
 * Use this to hook up any JS necessary to show element functionality.
 */

 theme.components = (function() {
  
  var $body = $(document.body);
  
  var selectors = {
    slideupAlertForm: '[data-slideup-alert-form]',
    qaSetMax: '[data-qa-set-max]',
    qaToggleEnabled: '[data-qa-toggle-enabled]',
    qa: '[data-quantity-adjuster]'
  };

  if( !$body.is('.template-page-components') ){
    return;
  }

  $(selectors.slideupAlertForm).on('submit', function(e) {
    e.preventDefault();

    new slate.models.SlideupAlert({
      title: $(this).find('input[name="title"]').val(),
      text: $(this).find('input[name="text"]').val()
    });
  });

  // Quantity Adjuster
  $(selectors.qaSetMax).on('click', function(e) {
    $(selectors.qa).find('input[type="number"]').attr('max', $(e.currentTarget).data('qa-set-max'));
  });

  $(selectors.qaToggleEnabled).on('click', function(e) {
    var $qaInput = $(selectors.qa).find('input[type="number"]');
    $qaInput.attr('disabled', !$qaInput.is(':disabled'));
  });

  $body.on('click', 'a[href="#"]', function(){
    return false;
  });

})();


(function($) {

  var $window       = $(window);
  var $document     = $(document);
  var $body         = $(document.body);

  $(document).ready(function() {
    var sections = new slate.Sections();
    sections.register('product', theme.Product);
    sections.register('collection', theme.Collection);
    sections.register('pencil-banner', theme.PencilBanner);
    sections.register('subscription-slideup', theme.SubscriptionSlideup);
    sections.register('instagram-feed', theme.InstagramFeed);
    sections.register('slideshow', theme.Slideshow);
    sections.register('header', theme.Header);
    sections.register('footer', theme.Footer);
    sections.register('ajax-cart', theme.AjaxCart);
    sections.register('cart', theme.Cart);
    sections.register('mobile-menu', theme.MobileMenu);
    sections.register('blog', theme.Blog);
    sections.register('blog-powered', theme.BlogPowered);
    sections.register('article-grid', theme.ArticleCarousel);
    sections.register('product-carousel', theme.ProductCarousel);
    sections.register('video-carousel', theme.VideoCarousel);
    sections.register('banner-carousel', theme.BannerCarousel);
    sections.register('search', theme.Search);
    sections.register('cms-page', theme.CMSPage);

    $('.in-page-link').on('click', function(evt) {
      slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
    });

    // Common a11y fixes
    slate.a11y.pageLinkFocus($(window.location.hash));

    // Target tables to make them scrollable
    slate.rte.wrapTables({
      $tables: $('.rte table'),
      tableWrapperClass: 'table-responsive'
    });

    // Target iframes to make them responsive
    var iframeSelectors =
      '.rte iframe[src*="youtube.com/embed"],' +
      '.rte iframe[src*="player.vimeo"]';

    slate.rte.wrapIframe({
      $iframes: $(iframeSelectors),
      iframeWrapperClass: 'rte__video-wrapper'
    });

    // Apply UA classes to the document
    slate.utils.userAgentBodyClass();

    // Apply a specific class to the html element for browser support of cookies.
    if (slate.utils.cookiesEnabled()) {
      document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
    }

    // Chosen JS plugin for select boxes
    slate.utils.chosenSelects();

    // Form event handling / validation
    slate.forms.initialize();

    // START - Global handler for collapse plugin to add state class for open panels
    var panelIsOpenClass = 'is-open';

    $document.on('show.bs.collapse', '.collapse', function(e) {
      $(e.currentTarget).parents('.panel').addClass(panelIsOpenClass);
    });

    $document.on('hide.bs.collapse', '.collapse', function(e) {
      $(e.currentTarget).parents('.panel').removeClass(panelIsOpenClass);
    });

    $('.collapse.in').each(function() {
      $(this).parents('.panel').addClass(panelIsOpenClass);
    });
    // END - Global handler for collapse plugin to add state class for open panels
  });

  // Initialize popovers using data attributes
  $(function () {
    $('[data-toggle="popover"]').popover()
  });


}(jQuery));
